import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import FileIcon from "../../custom/FileIcon";
import $, { event } from "jquery";
import API from "../../helpers/endpointservice";
import axios from "axios";
import WarningComponent from "../../helpers/modal";
import { toast } from "react-toastify";
import Toaster from "../../helpers/toaster";
import CommonIcon from "../../helpers/icons";
import UserStatus from "../../helpers/status";
import PaginationComponent from "../../helpers/Pagination";
import moment from "moment";
import Loader from "../../helpers/loader";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import UserRole from "../../helpers/role";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};

const manualEntryOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

class TrainingRecords extends React.Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.inputFileAdd = React.createRef();
    this.state = {
      order: "desc",
      sortBy: "trainingRequestId",
      currentUser: "",
      isTrainingLoader: false,
      height: window.innerHeight,
      isTab: false,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      isSMobile: false,
      isFormValid: false,
      validationMsg: false,
      pendingTrainingList: [
        {
          employeeCode: 0,
        },
      ],
      isSearch: false,
      trainingComments: "",
      validateComments: false,
      pendingTrainingView: {
        id: 0,
        trainingRequestId: "",
        courseCode: "",
        courseTitle: "",
        trainingStatusId: 0,
        employeeName: "",
        employeeCode: "",
        requestedFor: "",
        requestedBy: "",
        trainingRequestorId: 0,
        requestedDate: "",
        startDate: "",
        endDate: "",
        statusId: 0,
        status: "",
        currentStatus: "",
        trainingBond: {
          fileId: 0,
          fileName: "",
        },
        certificate: {
          fileId: 0,
          fileName: "",
        },
        fileUrl: "",
      },
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedBy: "",
        requestedDate: null,
        currentStatus: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        courseQuestionnaireStatus: "",
        pteStatus: "",
        startDate: null,
        endDate: null,
        isManualTraining: "",
      },
      employeeNameEmpty: false,
      selectEmployeeName: [],
      employeeNameList: [],
      currentPage: 1,
      perPage: 20,
      totalCount: 20,
      historyLogList: [],
      UserId: 0,
      pageNewCount: false,
      isView: true,
      isLou: false,
      isPte: false,
      isCourse: false,
      PTE: [],
      pteAnswersOption: [],
      pteJobAnswerOption: [],
      pteJob: [],
      courseAdd: [],
      CourseQuestAnswers: [],
      LouDetails: {},
      LouAnswers: {},
      currentStatusList: [],
      currentStatus: [],
      louStatus: [],
      louStatusList: [],
      trainingBondStatus: [],
      trainingBondstatusList: [],
      pteStatus: [],
      pteStatusList: [],
      manualEntryList: [],
      certificateStatus: [],
      certificateStatusList: [],
      courseQuestionnaireStatus: [],
      cqStatusList: [],
      courseCodeList: [],
      trainingRecord: {
        courseId: 0,
        courseCode: "",
        selectedCourse: "",
        userId: 0,
        userCode: "",
        selectedEmployee: "",
        startDate: null,
        endDate: null,
        certificateExpiryDate: null,
        curentStatus: "string",
        currentStatusSelected: null,
      },
      // mandatoryFieldNames: [
      //   "selectedCourse",
      //   "selectedEmployee",
      //   "currentStatusSelected",
      // ],
      mandatoryFieldNames: [
        "selectedCourse",
        "selectedEmployee",
        "startDate",
        "endDate",
        "currentStatusSelected",
      ],
      mandatoryFieldNamesEdit: ["startDate", "endDate"],
      trainingRecordsErrHandler: {},
      manualTrainingStatus: [],
      trainingAttachments: {},
      trainingAttachmentName: "",
      isEditableTraining: false,
      trainingEditData: {
        currentStatus: "",
        expiryDate: null,
        IsUpdateExpiryDate: false,
        trainingAttachmentName: "",
      },
      dateOnChange: false,
      additionalDates: [null],
      additionalDatesView: [],
      additionalErrors: [""],
      additionalDatesDuplicate: false,
      isNonConsecutiveDates: false,
      isNonConsecutiveDatesView: false,
    };
    this.focusRef = React.createRef();
  }
  componentDidMount() {
    let user = localStorage.getItem("UserId");
    // let value = localStorage.getItem("Role");
    this.state.UserId = user;
    let userrole = localStorage.getItem("Role");
    this.state.currentUser = userrole?.split(",")[0];
    // this.state.currentUser = value;
    this.setState({}, () => {
      this.GetMyPendingTrainingList(this.state.currentPage, this.state.perPage);
    });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
    this.getCourseQuestAnswers();
    this.getPteAnswerOptions();
    this.getPteJobAnswerOptions();
    this.getEmployeeName();
    this.getCurrentStatus();
    this.GetCoursesList();
    // this.getCertificateStatus();
    // this.getCqStatus();
    // this.getTrainingBondStatus();
    // this.getPteStatus();
    // this.getLouStatus();
  }

  resize = () => {
    if (window.innerWidth < 1280) {
      this.state.isTab = true;
    } else {
      this.state.isTab = false;
    }
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }
    if (window.innerWidth < 300 && window.innerWidth > 399) {
      this.state.isSMobile = true;
    } else {
      this.state.isSMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };

  getCourseQuestAnswers = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_COURSE_QUEST_ANSWERS).then((res) => {
      if (res.status === 200) {
        const evaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));

        this.state.CourseQuestAnswers = evaluationAns;
        this.setState({});
      }
    });
  };

  getPteAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_EVAL_ANS).then((res) => {
      if (res.status === 200) {
        const pteEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteAnswersOption = pteEvaluationAns;
        this.setState({});
      }
    });
  };

  getPteJobAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_SKILL_STATUS).then((res) => {
      if (res.status === 200) {
        const pteJobEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteJobAnswerOption = pteJobEvaluationAns;
        this.setState({});
      }
    });
  };

  GetMyPendingTrainingList = (currentpage, perpage) => {
    const { searchInputData, isSearch } = this.state;
    this.setState({ isTrainingLoader: true });
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_TRAINING_RECORDS_LIST}?sortBy=${this.state.sortBy}&isSortAscending=${order}&pageNumber=${currentpage}&pageSize=${perpage}`;
    let searchValues = {
      requestId: searchInputData.trainingRequestId || null,
      employeeCode: searchInputData.employeeCode || null,
      employeeName: this.state.selectEmployeeName?.value?.split(",")[2] || null,
      courseCode: searchInputData.courseCode || null,
      courseTitle: searchInputData.courseTitle || null,
      requestedBy: searchInputData.requestedBy || null,
      currentStatus: searchInputData.currentStatus || null,
      requestedDate:
        searchInputData.requestedDate?.toISOString()?.slice(0, 10) || null,
      // startDate:searchInputData.
      trainingBondStatus: searchInputData.trainingBondStatus || null,
      certificateStatus: searchInputData.certificateStatus || null,
      louStatus: searchInputData.louStatus || null,
      courseQuestionnaireStatus:
        searchInputData.courseQuestionnaireStatus || null,
      pteStatus: searchInputData.pteStatus || null,
      startDate: searchInputData.startDate?.toISOString()?.slice(0, 10) || null,
      endDate: searchInputData.endDate?.toISOString()?.slice(0, 10) || null,
      isManualTraining: searchInputData.isManualTraining || null,
    };
    axios({
      method: "POST",
      url: apiUrl,
      data: isSearch === true ? searchValues : {},
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.pendingTrainingList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.setState({ isTrainingLoader: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false, isSearch: false });
        // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  fetchPaginationList = (currentpage, perpage) => {
    this.setState(
      {
        currentPage: currentpage,
        perPage: perpage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.GetMyPendingTrainingList(currentpage, perpage);
      },
    );
  };

  sortTable = (name) => {
    let sortData = this.state.pendingTrainingList;
    if (sortData.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      // this.state.currentPage = 1;
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState(
        {
          currentPage: 1,
        },
        () => {
          this.GetMyPendingTrainingList(
            this.state.currentPage,
            this.state.perPage,
          );
        },
      );
    }
  };
  openTrainingDetails = (trainingRequestId) => {
    this.setState({ isTrainingLoader: true });
    this.getPendingTraningDetails(trainingRequestId);
    this.setState({
      isView: true,
      isLou: false,
      isCourse: false,
      isPte: false,
      validateComments: false,
      trainingComments: "",
    });
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("propertiesScreen"));
    // myOffcanvas.show();
    // const backdropElement = document.querySelector('.offcanvas-backdrop');
    // if (backdropElement) {
    //   backdropElement.remove();
    // }
    // $("body").addClass("scrollhide");
  };

  getCourseQuestionnaireById = (id) => {
    let apiUrl = `${API.GET_COURSE_QUESTIONAIRE}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.courseAdd = res.data.questions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isTrainingLoader: false });
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getLouById = (id) => {
    let apiUrl = `${API.GET_PENDING_LOU}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.LouDetails = res.data;
          this.state.isRequestLoader = false;
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getPteById = (id) => {
    let apiUrl = `${API.GET_PTE_BY_ID}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.PTE = res.data.pteQuestions;
          this.state.pteJob = res.data.jobQuestions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  mergeAndSortDates = (startDate, endDate, selectedDates = []) => {
    const allDates = [startDate, endDate, ...(selectedDates || [])].filter(
      Boolean,
    ); // remove null / undefined

    // Remove duplicates + sort
    const uniqueSortedDates = [...new Set(allDates)]
      .sort((a, b) => new Date(a) - new Date(b))
      .map((date) => moment(date).format("DD-MMM-YYYY"));

    return uniqueSortedDates;
  };

  splitDates = (dateArray = []) => {
    if (!Array.isArray(dateArray) || dateArray.length === 0) {
      // throw new Error("At least one date is required");
      return {
        startDate: null,
        endDate: null,
        selectedDates: [],
      };
    }

    const sorted = [...dateArray].sort((a, b) => new Date(a) - new Date(b));

    // 👉 If only one date
    if (sorted.length === 1) {
      return {
        startDate: sorted[0],
        endDate: sorted[0],
        selectedDates: [],
      };
    }

    // 👉 If multiple dates
    return {
      startDate: sorted[0],
      endDate: sorted[sorted.length - 1],
      selectedDates: sorted.slice(1, sorted.length - 1),
    };
  };

  getPendingTraningDetails = (traningId) => {
    this.getHistoryLogList(traningId);
    let apiUrl = `${API.GET_TRAINING_REQUEST_ID}?requestId=${traningId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          // this.setState({
          //   isTrainingLoader: false,
          //   isEditableTraining: false
          // })
          this.state.pendingTrainingView = res.data;
          let additionalDatesMerged = this.mergeAndSortDates(
            res.data.courseStartDate,
            res.data.courseEndDate,
            res.data.selectedDates,
          );
          this.setState({
            additionalDates: additionalDatesMerged || [null],
            additionalDatesView: additionalDatesMerged || [null],
            isNonConsecutiveDates: res.data.isNonConsecutiveDates || false,
            isNonConsecutiveDatesView: res.data.isNonConsecutiveDates || false,
            trainingRecord: {
              ...this.state.trainingRecord,
              startDate: res.data.courseStartDate,
              endDate: res.data.courseEndDate,
            },
          });
          if (res.data?.isPte === true) {
            const pendingStatusPte = res.data?.pteStatus
              ?.toLowerCase()
              ?.replace(/\s+/g, "");
            if (
              //    (pendingStatusPte === UserStatus.PTE2_UPDATE) ||
              //     (pendingStatusPte === UserStatus.PTE3_UPDATE) ||
              //     (pendingStatusPte === UserStatus.PTE1_REWORK) ||
              //     (pendingStatusPte === UserStatus.PTE2_REWORK) ||
              //     (pendingStatusPte === UserStatus.PTE3_REWORK) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE1_APPROVAL) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE2_APPROVAL) ||
              //     (pendingStatusPte === UserStatus.PENDING_FOR_PTE3_APPROVAL) ||
              //     (pendingStatusPte === UserStatus.PTE1_UPDATED) ||
              //     (pendingStatusPte === UserStatus.PTE2_UPDATED) ||
              //     (pendingStatusPte === UserStatus.PTE3_UPDATED) ||
              //     (pendingStatusPte === UserStatus.WAITING_FOR_PTE2) ||
              //     (pendingStatusPte === UserStatus.WAITING_FOR_PTE3) ||
              //     (pendingStatusPte === UserStatus.PTE_COMPLETED)
              !pendingStatusPte?.includes(UserStatus.PTE1_UPDATE)
            ) {
              this.getPteById(traningId);
            } else {
              this.state.PTE = [];
              this.setState({});
            }
          }

          if (res.data?.isLou === true) {
            if (res.data.louStatus?.toLowerCase() === UserStatus.SUBMITTED) {
              this.getLouById(traningId);
            } else {
              this.state.LouDetails = [];
              this.setState({});
            }
          }

          if (res.data?.isCourseQuestionnaire === true) {
            if (
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
                UserStatus.PENDING_FOR_CQ_REVIEW ||
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
                UserStatus.COMPLETED_STATUS
            ) {
              this.getCourseQuestionnaireById(traningId);
            } else {
              this.state.courseAdd = [];
              this.setState({});
            }
          }
          let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("propertiesScreen"),
          );
          myOffcanvas.show();
          const backdropElement = document.querySelector(".offcanvas-backdrop");
          if (backdropElement) {
            backdropElement.remove();
          }
          $("body").addClass("scrollhide");
          this.setState({
            isTrainingLoader: false,
            isEditableTraining: false,
          });
          // this.setState({}, () => {
          //   this.getHistoryLogList(traningId);
          // })
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getHistoryLogList = (trainingRequestId) => {
    let apiUrl = `${API.GET_HISTORY_LOG}?trainingRequestId=${trainingRequestId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status == 200) {
          this.setState({
            historyLogList: res.data,
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isTrainingLoader: false });
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  closeProperties = () => {
    this.setState({
      isPte: false,
      isCourse: false,
      isLou: false,
      isView: true,
      validateComments: false,
      trainingComments: "",
      LouDetails: [],
      courseAdd: [],
      PTE: [],
      pteJob: [],
    });
    this.trainingCancel();
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
  };

  opencancelRequest = () => {
    if (this.state.trainingComments !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("CancelCourseScreen"),
      );
      cancelPopup.show();
      $("#propertiesScreen").removeClass("show");
      $("#CancelCourseScreen").removeClass("show");
      $("body").addClass("scrollhide");
    } else {
      this.setState({
        validateComments: true,
      });
      this.focusRef.current.focus();
    }
  };

  handleRejectTraining = () => {
    var cancelRecord = [this.state.pendingTrainingView.id];
    this.setState({ isTrainingLoader: true });
    let apiUrl = `${API.GET_CANCEL_TRAINING}?userId=${this.state.UserId}&trainingRequestId=${this.state.pendingTrainingView.id}&comments=${this.state.trainingComments}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: []
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Request cancelled successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.closeProperties();
          this.GetMyPendingTrainingList(
            this.state.currentPage,
            this.state.perPage,
          );
          this.setState({ isTrainingLoader: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // toast.error("Failed to cancel request.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
      });
  };

  // Search Functionalities

  openSearch = () => {
    this.setState({ validationMsg: false });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("sideScreen"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
  };

  openTraningRecords = () => {
    this.resetTrainingRecords();
    this.setState({ validationMsg: false });
    // $("#offcanvasAddTraining").addClass("show");
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("offcanvasAddTraining"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
    // $("#sideScreenTraningRecords").removeClass("display-hide");
    // $("#sideScreenTraningRecords").addClass("visible-show");
    // $("body").addClass("scrollhide");
  };

  // GetEmployeeListAdmin = async (trainingId) => {
  //   let apiUrl = `${API.GET_ADMIN_EMPLOYEE_LIST}`;
  //   let res = await this.updateGetFunction(apiUrl);
  //   if (res.status === 200) {
  //     this.state.employeeNameList = res?.data?.map((employee) => {
  //       return {
  //         value: employee.id + "," + employee.employeeCode + "," + employee.userName,
  //         label: (
  //           <>
  //             <span>{employee.userName}</span>
  //           </>
  //         ),
  //       };
  //     });
  //     this.setState({
  //       isSubmissionFailed: false,
  //       isSubmissionLoader: false,
  //     });
  //   }
  // };
  getEmployeeName = () => {
    // this.setState({ isTrainingLoader: true });
    let apiUrl = `${API.GET_ADMIN_EMPLOYEE_LIST}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.employeeNameList = res?.data?.map((employee) => {
            return {
              value:
                employee.id +
                "," +
                employee.employeeCode +
                "," +
                employee.userName,
              label: (
                <>
                  <span>{employee.userName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getCurrentStatus = () => {
    let apiUrl = `${API.GET_CURRENT_STATUS}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.manualTrainingStatus =
            res?.data?.manualTrainingStatus?.map((status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            });
          this.state.currentStatusList = res?.data?.currentStatus?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            },
          );

          this.state.louStatusList = res?.data?.lou?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.trainingBondstatusList = res?.data?.trainingBond?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            },
          );

          this.state.cqStatusList = res?.data?.courseQuestionnaire?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            },
          );

          this.state.pteStatusList = res?.data?.pte?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.certificateStatusList = res?.data?.certificate?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            },
          );
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  // getLouStatus = () => {
  //   let apiUrl = `${API.GET_CURRENT_STATUS}?type=LOU`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.louStatusList = res?.data?.map((status) => {
  //           return {
  //             value: status,
  //             label: (
  //               <>
  //                 <span>{status}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error)
  //     })
  // }

  // getTrainingBondStatus = () => {
  //   let apiUrl = `${API.GET_CURRENT_STATUS}?type=Trainingbond`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.trainingBondstatusList = res?.data?.map((status) => {
  //           return {
  //             value: status,
  //             label: (
  //               <>
  //                 <span>{status}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error)
  //     })
  // }

  // getCqStatus = () => {
  //   let apiUrl = `${API.GET_CURRENT_STATUS}?type=CQ`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.cqStatusList = res?.data?.map((status) => {
  //           return {
  //             value: status,
  //             label: (
  //               <>
  //                 <span>{status}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error)
  //     })
  // }

  // getPteStatus = () => {
  //   let apiUrl = `${API.GET_CURRENT_STATUS}?type=PTE`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.pteStatusList = res?.data?.map((status) => {
  //           return {
  //             value: status,
  //             label: (
  //               <>
  //                 <span>{status}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error)
  //     })
  // }

  // getCertificateStatus = () => {
  //   let apiUrl = `${API.GET_CURRENT_STATUS}?type=Certificate`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.certificateStatusList = res?.data?.map((status) => {
  //           return {
  //             value: status,
  //             label: (
  //               <>
  //                 <span>{status}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error)
  //     })
  // }

  clearAllData = () => {
    this.setState({
      isSearch: false,
      validationMsg: false,
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        currentStatus: "",
        requestedBy: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        pteStatus: "",
        courseQuestionnaireStatus: "",
        startDate: null,
        endDate: null,
        isManualTraining: null,
      },
      employeeNameList: [],
      currentStatus: [],
      louStatus: [],
      trainingBondStatus: [],
      pteStatus: [],
      certificateStatus: [],
      courseQuestionnaireStatus: [],
      selectEmployeeName: [],
      trainingComments: "",
      validateComments: false,
      manualEntryList: [],
    });
  };

  clearSearchDetails = () => {
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.clearAllData();
    this.setState({}, () =>
      this.GetMyPendingTrainingList(this.state.currentPage, this.state.perPage),
    );
    $("#propertiesScreen").removeClass("show");
  };

  handleInputchange = (e, field) => {
    if (
      field === "startDate" ||
      field === "requestedDate" ||
      field === "endDate"
    ) {
      let reqDate = new Date(e);
      this.state.searchInputData[field] = reqDate;
    } else {
      this.state.searchInputData[field] = e.target.value;
    }

    this.setState({});
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevData) => ({
      ...prevData,
      [name]: value,
      trainingRecord: {
        ...prevData.trainingRecord,
        startDate: "",
        endDate: "",
      },
      trainingRecordsErrHandler: {
        ...prevData.trainingRecordsErrHandler,
        startDateErrMsg: "",
        endDateErrMsg: "",
      },
      additionalDates: [null],
      additionalErrors: [""],
      startDateEmpty: false,
      endDateEmpty: false,
      additionalDatesDuplicate: false,
    }));
    if (value == false) {
      this.setState({
        mandatoryFieldNames: [
          "selectedCourse",
          "selectedEmployee",
          "startDate",
          "endDate",
          "currentStatusSelected",
        ],
        mandatoryFieldNamesEdit: ["startDate", "endDate"],
      });
    } else {
      this.setState({
        mandatoryFieldNames: [
          "selectedCourse",
          "selectedEmployee",
          "currentStatusSelected",
        ],
        mandatoryFieldNamesEdit: [],
      });
    }
  };

  handleTrainingReqInputChange = (e, field) => {
    if (
      field === "startDate" ||
      field === "endDate" ||
      field == "certificateExpiryDate"
    ) {
      let reqDate = new Date(e);
      this.state.trainingRecord[field] = reqDate;
      if (field == "startDate") {
        this.state.trainingRecord["endDate"] = null;
      }
    } else {
      this.state.trainingRecord[field] = e.target.value;
    }

    this.setState({});
  };

  handleCurrentStatusTrainingRecord = (e) => {
    this.state.trainingRecord.currentStatusSelected = e;
    this.state.trainingRecord.currentStatus = e?.value ? e.value : "";
    this.setState({});
  };

  handleCurrentStatus = (e) => {
    this.state.currentStatus = e;
    this.state.searchInputData.currentStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCertificateStatus = (e) => {
    this.state.certificateStatus = e;
    this.state.searchInputData.certificateStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCqStatus = (e) => {
    this.state.courseQuestionnaireStatus = e;
    this.state.searchInputData.courseQuestionnaireStatus = e?.value
      ? e.value
      : "";
    this.setState({});
  };

  onchangeLouStatus = (e) => {
    this.state.louStatus = e;
    this.state.searchInputData.louStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeTbStatus = (e) => {
    this.state.trainingBondStatus = e;
    this.state.searchInputData.trainingBondStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangePteStatus = (e) => {
    this.state.pteStatus = e;
    this.state.searchInputData.pteStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeManualEntry = (e) => {
    this.state.manualEntryList = e;
    this.state.searchInputData.isManualTraining = e.value;
    this.setState({});
  };

  handleTBondComments = (e) => {
    this.setState({
      trainingComments: e.target.value,
    });
  };

  onchangeEmployeeName = (e, field) => {
    if (e === null) {
      this.state.employeeId = "";
      this.state.employeeCode = "";
      this.state.employeeName = "";
      this.state.selectEmployee = [];
      this.state.selectEmployeeName = [];
      this.state.searchInputData[field] = "";
      this.setState({});
    } else {
      this.state.employeeId = parseInt(e.value.split(",")[0]);
      this.state.employeeCode = e.value.split(",")[1];
      this.state.employeeName = e.value.split(",")[2];
      this.state.selectEmployee = e;
      this.state.searchInputData[field] = e.value;
      this.state.selectEmployeeName = e;
      this.setState({});
    }
  };

  onchangeEmployee = (e, field) => {
    if (e === null) {
      this.state.trainingRecord.userId = "";
      this.state.trainingRecord.userCode = "";
      this.state.trainingRecord.selectedEmployee = null;
      this.setState({});
    } else {
      this.state.trainingRecord.userId = parseInt(e.value.split(",")[0]);
      this.state.trainingRecord.userCode = e.value.split(",")[1];
      this.state.trainingRecord.selectedEmployee = e;
      this.setState({});
    }
  };

  onchangeCourse = (e, field) => {
    if (e == null) {
      this.state.trainingRecord.courseId = "";
      this.state.trainingRecord.courseCode = "";
      this.state.TrainingRecord.selectedCourse = null;
      this.setState({});
    } else {
      this.state.trainingRecord.courseId = parseInt(e.value.split(",")[0]);
      this.state.trainingRecord.courseCode = e.value.split(",")[1];
      this.state.trainingRecord.selectedCourse = e;
      this.setState({});
    }
  };

  validateSearchRecords = () => {
    const inputs = document.querySelectorAll(
      ".records-editinput-class[required]",
    );
    const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
    const isValid1 =
      this.state.selectEmployeeName?.length !== 0 ||
      this.state.searchInputData.requestedDate ||
      this.state.searchInputData.startDate ||
      this.state.searchInputData.endDate ||
      this.state.searchInputData.currentStatus?.length !== 0 ||
      this.state.searchInputData.trainingBondStatus?.length !== 0 ||
      this.state.searchInputData.louStatus?.length !== 0 ||
      this.state.searchInputData.pteStatus?.length !== 0 ||
      (this.state.searchInputData.isManualTraining?.length !== 0 &&
        this.state.searchInputData.isManualTraining != null) ||
      this.state.searchInputData.certificateStatus?.length !== 0 ||
      this.state.searchInputData.courseQuestionnaireStatus?.length !== 0;

    if (isValid || isValid1) {
      this.submitSearchDetails();
      this.setState({
        validationMsg: false,
      });
    } else {
      this.setState({
        validationMsg: true,
      });
    }
  };

  closeTrainingSearchModal = (text) => {
    if (text === "clear") {
      // this.handleFileClose();
      this.setState(
        {
          searchInputData: {
            trainingRequestId: "",
            employeeCode: "",
            employeeName: "",
            courseCode: "",
            courseTitle: "",
            requestedBy: "",
            requestedDate: null,
            currentStatus: "",
            trainingBondStatus: "",
            certificateStatus: "",
            louStatus: "",
            courseQuestionnaireStatus: "",
            pteStatus: "",
            startDate: null,
            endDate: null,
            isManualTraining: "",
          },
          selectEmployeeName: [],
          currentStatus: [],
          trainingBondStatus: [],
          certificateStatus: [],
          louStatus: [],
          courseQuestionnaireStatus: [],
          pteStatus: [],
          manualEntryList: [],
          validationMsg: false,
        },
        () => {
          this.submitSearchDetails();
        },
      );
    }
    document.getElementById("closeSideScreen").click();
  };

  submitSearchDetails = () => {
    this.state.isSearch = true;
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () =>
      this.GetMyPendingTrainingList(this.state.currentPage, this.state.perPage),
    );
    document.getElementById("closeSideScreen").click();
    $("body").removeClass("scrollhide");
  };

  handleFilesOpen = (FileId) => {
    // this.setState({ isTrainingLoader: true })
    let apiUrl = `${API.GET_FILES_URL}?fileId=${FileId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            pendingTrainingView: {
              ...this.state.pendingTrainingView,
              fileUrl: res.data,
            },
            // isTrainingLoader: false
          });
          res.data && window.open(res.data);
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  showViewStatus = () => {
    this.state.isTrainingLoader = true;
    setTimeout(() => {
      this.state.isTrainingLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: false,
      isView: true,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
    $("body").addClass("scrollhide");
  };

  showLouStatus = () => {
    this.state.isTrainingLoader = true;
    setTimeout(() => {
      this.state.isTrainingLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: true,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
    $("body").addClass("scrollhide");
  };

  removeDate = (index) => {
    const newDates = [...this.state.additionalDates];
    const newErrors = [...this.state.additionalErrors];
    newDates.splice(index, 1);
    newErrors.splice(index, 1);
    this.setState({ additionalDates: newDates, additionalErrors: newErrors });
  };

  handleAdditionalDateChange = (date, index) => {
    const formattedDate = date ? moment(date).format("DD-MMM-YYYY") : null;
    const newDates = [...this.state.additionalDates];
    const newErrors = [...this.state.additionalErrors];
    newDates[index] = formattedDate;
    newErrors[index] = ""; // reset error when date is selected
    this.setState({ additionalDates: newDates, additionalErrors: newErrors });
  };

  handleDateChange = (event, field) => {
    const inputDate = event;
    if (field === "startDate") {
      this.state.startDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      this.state.endDate = null;
      this.state.startDateEmpty = false;
    }
    if (field === "endDate") {
      this.state.endDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      this.state.endDateEmpty = false;
    }
    this.setState({}, () => {});
  };

  showPteStatus = () => {
    this.state.isTrainingLoader = true;
    setTimeout(() => {
      this.state.isTrainingLoader = false;
    }, 1000);
    this.setState({
      isPte: true,
      isLou: false,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
    $("body").addClass("scrollhide");
  };

  showCourseStatus = () => {
    this.state.isTrainingLoader = true;
    setTimeout(() => {
      this.state.isTrainingLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: true,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen"),
    );
    myOffcanvas.show();
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
    $("body").addClass("scrollhide");
  };

  GetCoursesList = () => {
    let apiUrl = `${API.GET_COURSE_CODE}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.courseCodeList = res.data.map((course) => {
            return {
              value:
                course.courseId +
                "," +
                course.courseCode +
                "," +
                course.courseName,
              label: (
                <>
                  <span>{course.courseCode + " - " + course.courseName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  fileNameAttachments = (event) => {
    this.setState({
      trainingAttachments: event.target?.files[0],
      trainingAttachmentName: event.target?.files[0]?.name,
    });
  };

  fileNameAttachmentsEdit = (event) => {
    this.setState({
      trainingAttachments: event.target?.files[0],
      trainingEditData: {
        ...this.state.trainingEditData,
        trainingAttachmentName: event.target?.files[0]?.name,
      },
    });
  };

  submitTrainingRecord = () => {
    let errHandler = {};
    this.state.mandatoryFieldNames.forEach((x) => {
      if (x == "startDate") {
        if (!this.state.trainingRecord[x]) {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else if (x == "endDate") {
        if (!this.state.trainingRecord[x]) {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else {
        if (this.state.trainingRecord[x]) {
          $("#" + x).removeClass("required-field");
        } else {
          $("#" + x).addClass("required-field");
        }
      }
      errHandler[`${x}ErrMsg`] = !this.state.trainingRecord[x] ? true : false;
    });
    this.setState({
      trainingRecordsErrHandler: errHandler,
    });
    const newErrors = [];
    let isDuplicate=this.state.additionalDatesDuplicate;
    if (this.state.isNonConsecutiveDates) {
      this.state.additionalDates.forEach((date, index) => {
        if (date === null || date === undefined || date === "") {
          newErrors.push("This field is required");
        } else {
          // const current = new Date(date);
          // const start = new Date(this.state.trainingRecord.startDate);
          // const end = new Date(this.state.trainingRecord.endDate);

          // if (start && end && (current <= start || current >= end)) {
          //   newErrors.push("Date must be between start and end date");
          // } else {
          newErrors.push("");
          // }
        }
      });
      if (
        new Set(
          this.state.additionalDates.filter(
            (d) => d !== null && d !== undefined && d !== "",
          ),
        ).size !==
        this.state.additionalDates.filter(
          (d) => d !== null && d !== undefined && d !== "",
        ).length
      ) {
        isDuplicate=true;
        this.setState({ additionalDatesDuplicate: true });
      } else {
        isDuplicate=false;
        this.setState({ additionalDatesDuplicate: false });
      }
      this.setState({ additionalErrors: newErrors });
    }

    if (
      Object.values(errHandler).indexOf(true) > -1 ||
      newErrors.some((error) => error !== "") ||
      isDuplicate
    ) {
      return;
    }
    let trainingDates = this.state.additionalDates
      .filter((date) => date !== null && date !== undefined && date !== "")
      .map((date) => moment(date).format("YYYY-MM-DD"));
    let splitDates = this.splitDates(trainingDates);

    let dataObj = {
      Id: 0,
      CourseId: this.state.trainingRecord.courseId,
      isNonConsecutiveDates: this.state.isNonConsecutiveDates,
      UserId: this.state.trainingRecord.userId,
      // "Enddate": moment(this.state.trainingRecord.endDate).toISOString(),
      Currentstatus: this.state.trainingRecord.currentStatus,
      CertificateId: 0,
      ExpiryDate: this.state.trainingRecord.certificateExpiryDate
        ? moment(this.state.trainingRecord.certificateExpiryDate).toISOString()
        : null,
      IsUpdateExpiryDate: false,
      selectedDates:
        splitDates.selectedDates.length > 0 ? splitDates.selectedDates : null,
      Startdate: this.state.isNonConsecutiveDates
        ? moment(splitDates.startDate).toISOString()
        : moment(this.state.trainingRecord.startDate).toISOString(),
      // "Startdate": moment(this.state.trainingRecord.startDate).toISOString(),
      Enddate: this.state.isNonConsecutiveDates
        ? moment(splitDates.endDate).toISOString()
        : moment(this.state.trainingRecord.endDate).toISOString(),
    };
    let uploadformData = new FormData();
    uploadformData?.append("files", this.state.trainingAttachments);
    uploadformData?.append("dataitem", JSON.stringify(dataObj));

    let apiUrl = API.POSTPUT_MANUAL_TRAININGS + "?userId=" + this.state.UserId;
    this.setState({ isTrainingLoader: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: uploadformData,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.status == true) {
            this.setState({ isTrainingLoader: false, currentPage: 1 });
            this.closeTrainingModal();
            this.GetMyPendingTrainingList(
              this.state.currentPage,
              this.state.perPage,
            );
            toast.success("Training added successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          } else {
            this.setState({ isTrainingLoader: false });
            if (res.data?.message) {
              toast.error(res.data?.message, {
                position: toast.POSITION.TOP_RIGHT,
                color: "#fff",
              });
            }
          }
        } else {
          this.setState({ isTrainingLoader: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  addDate = () => {
    this.setState({
      additionalDates: [...this.state.additionalDates, null],
      additionalErrors: [...this.state.additionalErrors, ""],
    });
  };

  resetTrainingRecords() {
    let errHandler = {};
    this.state.mandatoryFieldNames.forEach((x) => {
      if (x == "startDate" || x == "endDate") {
        $(".password-input-valid .MuiOutlinedInput-notchedOutline").css(
          "border-color",
          "#edebe9",
        );
      } else {
        $("#" + x).removeClass("required-field");
      }
      errHandler[`${x}ErrMsg`] = false;
    });
    this.setState({
      trainingRecordsErrHandler: errHandler,
      trainingAttachments: {},
      trainingAttachmentName: "",
      selectCourse: null,
      additionalDates: [null],
      additionalDatesView: [],
      additionalErrors: [""],
      additionalDatesDuplicate: false,
      isNonConsecutiveDates: false,
      isNonConsecutiveDatesView: false,
      mandatoryFieldNames: [
        "selectedCourse",
        "selectedEmployee",
        "startDate",
        "endDate",
        "currentStatusSelected",
      ],
      trainingRecord: {
        Id: 0,
        courseId: 0,
        userId: 0,
        startDate: null,
        endDate: null,
        currentStatus: "",
        CertificateId: 0,
        certificateExpiryDate: null,
        IsUpdateExpiryDate: false,
        selectedEmployee: "",
        selectCourse: "",
        selectedCourse: "",
        currentStatusSelected: null,
      },
    });
  }

  closeTrainingModal = () => {
    this.resetTrainingRecords();
    document.getElementById("closeAddTrainingModal").click();
    // $("#offcanvasAddTraining").removeClass("show");
    // $("#sideScreenTraningRecords").removeClass('visible-show');
    // $("#sideScreenTraningRecords").addClass('display-hide');
    // $('body').removeClass('scrollhide');
  };

  handleFileCloseEdit = () => {
    this.setState({
      // dateOnChange: true,
      trainingAttachments: {},
      trainingEditData: {
        ...this.state.trainingEditData,
        trainingAttachmentName: "",
        expiryDate: null,
      },
    });
    $("#inputGroupAdd").val("");
    $("#inputGroupFileEdit").val("");
  };

  handleFileClose = () => {
    this.setState({
      trainingAttachments: {},
      trainingAttachmentName: "",
    });
    $("#inputGroupAdd").val("");
    $("#inputGroupFileEdit").val("");
  };

  trainingEdit = () => {
    this.setState({
      isEditableTraining: true,
      dateOnChange: false,
      trainingEditData: {
        currentStatus: this.state.manualTrainingStatus?.filter(
          (status) =>
            status.value == this.state.pendingTrainingView?.currentStatus,
        )[0],
        expiryDate: this.state.pendingTrainingView.certificateExpiryDate,
        IsUpdateExpiryDate: false,
        trainingAttachmentName:
          this.state.pendingTrainingView.certificate.fileName || "",
      },
      additionalDatesView: this.state.additionalDatesView,
      isNonConsecutiveDates: this.state.isNonConsecutiveDatesView,
      trainingRecord: {
        ...this.state.trainingRecord,
        startDate: this.state.pendingTrainingView.trainingStartDate,
        endDate: this.state.pendingTrainingView.trainingEndDate,
      },
      additionalErrors: this.state.additionalDatesView
        ? new Array(this.state.additionalDatesView.length).fill("")
        : [""],
    });
  };

  trainingCancel = () => {
    this.setState({
      isEditableTraining: false,
    });
  };

  handleTrainingEditChange = (e, str, eidtStr) => {
    if (str === "currentStatus") {
      this.setState({
        ...this.state,
        trainingEditData: {
          ...this.state.trainingEditData,
          currentStatus: e,
        },
      });
    } else {
      let reqDate = new Date(e);
      this.setState({
        dateOnChange: true,
        trainingEditData: {
          ...this.state.trainingEditData,
          expiryDate: reqDate,
        },
      });
    }
  };

  submitTrainingUpdate = () => {
    if (this.state.pendingTrainingView?.isManualTraining === true) {
      this.trainingUpdate();
      return;
    }

    this.trainingDateOnlyUpdate();
  };

  trainingDateOnlyUpdate = () => {
    const updateComments = this.state.trainingComments?.trim()
      ? this.state.trainingComments.trim()
      : null;
    let errHandler = {};
    this.state.mandatoryFieldNamesEdit.forEach((x) => {
      if (x == "startDate") {
        if (!this.state.trainingRecord[x]) {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else if (x == "endDate") {
        if (!this.state.trainingRecord[x]) {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else {
        if (this.state.trainingRecord[x]) {
          $("#" + x).removeClass("required-field");
        } else {
          $("#" + x).addClass("required-field");
        }
      }
      errHandler[`${x}ErrMsg`] = !this.state.trainingRecord[x] ? true : false;
    });
    this.setState({
      trainingRecordsErrHandler: errHandler,
    });

    const newErrors = [];
    let isDuplicate = this.state.additionalDatesDuplicate;
    if (this.state.isNonConsecutiveDates) {
      this.state.additionalDates.forEach((date) => {
        if (date === null || date === undefined || date === "") {
          newErrors.push("This field is required");
        } else {
          newErrors.push("");
        }
      });
      if (
        new Set(
          this.state.additionalDates.filter(
            (d) => d !== null && d !== undefined && d !== "",
          ),
        ).size !==
        this.state.additionalDates.filter(
          (d) => d !== null && d !== undefined && d !== "",
        ).length
      ) {
        isDuplicate = true;
        this.setState({ additionalDatesDuplicate: true });
      } else {
        isDuplicate = false;
        this.setState({ additionalDatesDuplicate: false });
      }
      this.setState({ additionalErrors: newErrors });
    }

    if (
      Object.values(errHandler).indexOf(true) > -1 ||
      newErrors.some((error) => error !== "") ||
      isDuplicate
    ) {
      return;
    }

    let trainingDates = this.state.additionalDates
      .filter((date) => date !== null && date !== undefined && date !== "")
      .map((date) => moment(date).format("YYYY-MM-DD"));
    let splitDates = this.splitDates(trainingDates);

    let dataObj = {
      id: this.state.pendingTrainingView?.id,
      startDate: this.state.isNonConsecutiveDates
        ? moment(splitDates.startDate).format("YYYY-MM-DD")
        : moment(this.state.trainingRecord.startDate).format("YYYY-MM-DD"),
      endDate: this.state.isNonConsecutiveDates
        ? moment(splitDates.endDate).format("YYYY-MM-DD")
        : moment(this.state.trainingRecord.endDate).format("YYYY-MM-DD"),
      selectedDates: this.state.isNonConsecutiveDates
        ? splitDates.selectedDates
        : [],
      isNonConsecutiveDates: this.state.isNonConsecutiveDates,
      comments: updateComments,
    };

    let apiUrl = API.UPDATE_TRAINING_RECORD + "?userId=" + this.state.UserId;
    this.setState({ isTrainingLoader: true });
    axios({
      method: "PUT",
      url: apiUrl,
      data: dataObj,
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({ isTrainingLoader: false, currentPage: 1 });
          $("#propertiesScreen").removeClass("show");
          $("body").removeClass("scrollhide");
          this.setState({
            isEditableTraining: false,
          });
          this.GetMyPendingTrainingList(
            this.state.currentPage,
            this.state.perPage,
          );
          toast.success("Training updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
        } else {
          this.setState({ isTrainingLoader: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  trainingUpdate = () => {
    const updateComments = this.state.trainingComments?.trim()
      ? this.state.trainingComments.trim()
      : null;
    const isCertificateNeedToRemove =
      !this.state.trainingEditData?.trainingAttachmentName ||
      this.state.trainingEditData.trainingAttachmentName.trim() === "";
    let dataObj = {
      Id: this.state.pendingTrainingView?.id,
      Currentstatus: this.state.trainingEditData.currentStatus?.value,
      // "CertificateId": (this.state.trainingEditData?.trainingAttachmentName !== "" && this.state.trainingAttachments?.name !== "" && this.state.trainingAttachments?.name !== undefined) ? 0 : this.state.trainingEditData?.trainingAttachmentName === "" ? 0 : this.state.pendingTrainingView.certificate.fileId,
      CertificateId: this.state.pendingTrainingView.certificate.fileId
        ? this.state.pendingTrainingView.certificate.fileId
        : 0,
      ExpiryDate: this.state.trainingEditData.expiryDate
        ? moment(this.state.trainingEditData.expiryDate).toISOString()
        : null,
      IsUpdateExpiryDate: this.state.dateOnChange == true ? true : false,
      IsCertificateNeedToRemove: isCertificateNeedToRemove,
      comments: updateComments,
    };
    let errHandler = {};
    this.state.mandatoryFieldNamesEdit.forEach((x) => {
      if (x == "startDate") {
        if (!this.state.trainingRecord[x]) {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".startDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else if (x == "endDate") {
        if (!this.state.trainingRecord[x]) {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#ee192d",
          );
        } else {
          $(".endDate .MuiOutlinedInput-notchedOutline").css(
            "border-color",
            "#edebe9",
          );
        }
      } else {
        if (this.state.trainingRecord[x]) {
          $("#" + x).removeClass("required-field");
        } else {
          $("#" + x).addClass("required-field");
        }
      }
      errHandler[`${x}ErrMsg`] = !this.state.trainingRecord[x] ? true : false;
    });
    this.setState({
      trainingRecordsErrHandler: errHandler,
    });
    const newErrors = [];
    let isDuplicate=this.state.additionalDatesDuplicate;
    if (this.state.isNonConsecutiveDates) {
      this.state.additionalDates.forEach((date, index) => {
        if (date === null || date === undefined || date === "") {
          newErrors.push("This field is required");
        } else {
          newErrors.push("");
        }
      });
      if (
        new Set(
          this.state.additionalDates.filter(
            (d) => d !== null && d !== undefined && d !== "",
          ),
        ).size !==
        this.state.additionalDates.filter(
          (d) => d !== null && d !== undefined && d !== "",
        ).length
      ) {
        isDuplicate=true;
        this.setState({ additionalDatesDuplicate: true });
      } else {
        isDuplicate=false;
        this.setState({ additionalDatesDuplicate: false });
      }
      this.setState({ additionalErrors: newErrors });
    }

    if (
      Object.values(errHandler).indexOf(true) > -1 ||
      newErrors.some((error) => error !== "") ||
      isDuplicate
    ) {
      return;
    }
    let trainingDates = this.state.additionalDates
      .filter((date) => date !== null && date !== undefined && date !== "")
      .map((date) => moment(date).format("YYYY-MM-DD"));
    let splitDates = this.splitDates(trainingDates);

    dataObj = {
      ...dataObj,
      selectedDates:
        splitDates.selectedDates.length > 0 ? splitDates.selectedDates : null,
      Startdate: this.state.isNonConsecutiveDates
        ? moment(splitDates.startDate).toISOString()
        : moment(this.state.trainingRecord.startDate).toISOString(),
      // "Startdate": moment(this.state.trainingRecord.startDate).toISOString(),
      Enddate: this.state.isNonConsecutiveDates
        ? moment(splitDates.endDate).toISOString()
        : moment(this.state.trainingRecord.endDate).toISOString(),
      isNonConsecutiveDates: this.state.isNonConsecutiveDates,
    };

    if (
      dataObj?.Currentstatus &&
      dataObj?.Currentstatus != null &&
      dataObj?.Currentstatus != undefined
    ) {
      $("#editCurrentStatus").removeClass("required-field");
      let uploadformData = new FormData();
      uploadformData?.append("dataitem", JSON.stringify(dataObj));
      if (
        this.state.trainingEditData?.trainingAttachmentName !== "" &&
        this.state.trainingAttachments?.name !== "" &&
        this.state.trainingAttachments?.name !== undefined
      ) {
        uploadformData?.append("files", this.state.trainingAttachments);
      } else if (this.state.trainingEditData?.trainingAttachmentName === "") {
        uploadformData?.append("files", null);
      }

      let apiUrl =
        API.POSTPUT_MANUAL_TRAININGS + "?userId=" + this.state.UserId;
      this.setState({ isTrainingLoader: true });
      axios({
        method: "PUT",
        url: apiUrl,
        data: uploadformData,
      })
        .then((res) => {
          if (res.status === 200) {
            this.setState({ isTrainingLoader: false, currentPage: 1 });
            $("#propertiesScreen").removeClass("show");
            $("body").removeClass("scrollhide");
            this.setState({
              isEditableTraining: false,
              pendingTrainingView: {
                ...this.state.pendingTrainingView,
                currentStatus: this.state.pendingTrainingView.currentStatus,
                certificateExpiryDate:
                  this.state.pendingTrainingView.certificateExpiryDate,
                trainingAttachmentName:
                  this.state.trainingEditData?.trainingAttachmentName !== ""
                    ? this.state.trainingEditData?.trainingAttachmentName
                    : this.state.pendingTrainingView.certificate.fileName,
              },
            });
            this.GetMyPendingTrainingList(
              this.state.currentPage,
              this.state.perPage,
            );
            toast.success("Training updated successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          } else {
            this.setState({ isTrainingLoader: false });
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          this.setState({ isTrainingLoader: false });
          swal("Error!", "Something went wrong. Please try again.", "warning");
        });
    } else {
      $("#editCurrentStatus").addClass("required-field");
    }
  };

  AttachFiles = () => {
    if (this.inputFile?.current !== null) {
      this.inputFile.current.click();
    }
  };

  AttachFilesAdd = () => {
    if (this.inputFileAdd?.current !== null) {
      this.inputFileAdd.current.click();
    }
  };

  addDays = (date, days) => {
    if (!date) return null;
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  render() {
    const {
      isMobile,
      iswebMobile,
      validateComments,
      trainingComments,
      isSmallMobile,
      historyLogList,
      pendingTrainingList,
      pageNewCount,
      pendingTrainingView,
      isRadioMobile,
      isTrainingLoader,
      sortBy,
      order,
      isPte,
      isView,
      isCourse,
      isLou,
      LouDetails,
      pteAnswersOption,
      pteJobAnswerOption,
      pteJob,
      PTE,
      courseAdd,
      pendingApprovalsView,
    } = this.state;
    let { menuToggle } = this.props;
    return (
      <>
        {$("#propertiesScreen").hasClass("show") ||
        $("#sideScreen").hasClass("show") ||
        $("#offcanvasAddTraining").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div
          className={`${
            isMobile
              ? "main-body-mobile"
              : menuToggle
                ? "menu-main-body"
                : "main-body"
          } `}
        >
          <Loader isLoader={isTrainingLoader} />
          <>
            {isMobile == true ? (
              <div className={`p-0 mr-0 w-80 `}>
                <span
                  className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                >
                  <span className="mobile-title">Training records</span>
                  <div className="d-flex">
                    {(this.state.currentUser === UserRole.ADMIN ||
                      this.state.currentUser === UserRole.SYSTEMADMIN) && (
                      <span
                        className="cursor-pointer add-training-icon-training"
                        onClick={() => this.openTraningRecords()}
                      >
                        <CommonIcon fileName="addIcon" className="" />
                        <span className="pl-4 text-16-bold pt-1 pl-10px pr-20px">
                          {isRadioMobile ? "Add" : "Add Training Request"}
                        </span>
                      </span>
                    )}
                    <span onClick={() => this.openSearch()}>
                      <CommonIcon fileName="searchIcon1" />
                    </span>
                  </div>
                </span>
              </div>
            ) : (
              <div className="head-fixed">
                <div
                  className={` ${
                    menuToggle ? "width-100" : "width-filter"
                  } px-4 position-relative border-bottom row `}
                >
                  <div className="col-6 border-none title">
                    <CommonIcon fileName="trainingRecords" />
                    <span className="pl-10 head-span">Training records</span>
                  </div>
                  <div className="text-align-end title border-none display mt-3px col-6">
                    {(this.state.currentUser === UserRole.ADMIN ||
                      this.state.currentUser === UserRole.SYSTEMADMIN) && (
                      <span
                        className="cursor-pointer add-training-icon"
                        onClick={() =>
                          this.openTraningRecords()
                        } /*data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"*/
                      >
                        <CommonIcon fileName="addIcon" className="" />
                        <span className="pl-4 text-16-bold pt-1 pl-10px pr-20px">
                          Add Training Request
                        </span>
                      </span>
                    )}
                    <span
                      className="pr-30 cursor-pointer"
                      onClick={() => this.openSearch()}
                    >
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
          <Toaster />
          <div
            className={`${isMobile ? "training-mobiletable-style" : "common-pending-style"} table-responsive w-100`}
          >
            <div
              id="table-tr"
              className={`table-fixed-header ${isMobile ? "table-scroll-xy-mobile top-115px" : menuToggle ? "table-scroll-xy-menutoggle top-115px" : "table-scroll-xy top-115px"} table-list-view-bottom`}
            >
              <table
                className={`${isMobile ? "" : ""} table  fileListTable2  table-borderless table-hover `}
              >
                <thead>
                  <tr>
                    <td></td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("trainingRequestId")}
                    >
                      <span> Request ID </span>
                      {sortBy === "trainingRequestId" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("employeeCode")}
                    >
                      <span> Employee code </span>
                      {sortBy === "employeeCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("employeeName")}
                    >
                      <span> Employee name</span>
                      {sortBy === "employeeName" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseCode")}
                    >
                      <span> Course code</span>
                      {sortBy === "courseCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseTitle")}
                    >
                      <span> Course title</span>
                      {sortBy === "courseTitle" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("requestedBy")}
                    >
                      <span> Requested by</span>
                      {sortBy === "requestedBy" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("currentStatus")}
                    >
                      <span>Current status</span>
                      {sortBy === "currentStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("louStatus")}
                    >
                      <span>LOU status</span>
                      {sortBy === "louStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("trainingBondStatus")}
                    >
                      <span>Training bond status</span>
                      {sortBy === "trainingBondStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("pteStatus")}
                    >
                      <span>PTE status</span>
                      {sortBy === "pteStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("certificateStatus")}
                    >
                      <span>Certificate status</span>
                      {sortBy === "certificateStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("courseQuestionnaireStatus")
                      }
                    >
                      <span>CQ status</span>
                      {sortBy === "courseQuestionnaireStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("startDate")}
                    >
                      <span> Start date </span>
                      {sortBy === "startDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("endDate")}
                    >
                      <span> End date </span>
                      {sortBy === "endDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("requestedDate")}
                    >
                      <span> Requested date </span>
                      {sortBy === "requestedDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("isManualEntry")}
                    >
                      <span>Manual Entry </span>
                      {sortBy === "isManualEntry" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {pendingTrainingList.length !== 0 ? (
                    pendingTrainingList?.map((item, index) => (
                      <tr
                        id={"active" + item.id}
                        key={index}
                        className="requestRadioSelect"
                      >
                        <td></td>
                        <td className="width-150px">
                          <span>
                            <a
                              className="properties-view cursor-pointer"
                              onClick={() => this.openTrainingDetails(item.id)}
                            >
                              {item.trainingRequestId
                                ? item.trainingRequestId
                                : "-"}
                            </a>
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.employeeCode ? item.employeeCode : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.employeeName ? item.employeeName : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.courseCode ? item.courseCode : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.courseTitle ? item.courseTitle : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.requestedBy ? item.requestedBy : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item.currentStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.currentStatus ? item.currentStatus : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item?.louStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.louStatus ? item.louStatus : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item?.trainingBondStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.trainingBondStatus
                              ? item.trainingBondStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item?.pteStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.pteStatus ? item.pteStatus : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item?.certificateStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.certificateStatus
                              ? item.certificateStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span
                            style={{
                              color:
                                item?.courseQuestionnaireStatus
                                  ?.toLowerCase()
                                  ?.indexOf("pending") > -1
                                  ? "#c81e2e"
                                  : "#000",
                            }}
                          >
                            {item.courseQuestionnaireStatus
                              ? item.courseQuestionnaireStatus
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.trainingStartDate
                              ? moment(
                                  new Date(Date.parse(item.trainingStartDate)),
                                ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.trainingEndDate
                              ? moment(
                                  new Date(Date.parse(item.trainingEndDate)),
                                ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.requestedDate
                              ? moment(
                                  new Date(Date.parse(item.requestedDate)),
                                ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item?.isManualTraining == true ? "Yes" : "No"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={17} className="table-nodata text-center">
                        {"No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                  ? "common-submenu sidemenu-pagination"
                  : "common-submenu web-pagination"
            } pb-2 pt-2`}
          ></div>
        </div>

        <div
          className={` ${
            isView
              ? "offcanvasStyle"
              : isLou
                ? "offcanvas-lou mt-48"
                : isCourse
                  ? "course_questionnaire_add"
                  : isPte
                    ? "pte_add"
                    : ""
          } offcanvas  offcanvas-end  `}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="static"
          id="propertiesScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3 mt-10"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
              {pendingTrainingView.currentStatus}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${
                isMobile ? "pr-0" : ""
              }`}
              onClick={this.closeProperties}
            >
              <CommonIcon fileName="CrossIcon" />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div
              className={` d-flex text-12-normal pb-2 justify-content-start min-width-heading  `}
            >
              <div
                className={` ${
                  isView ? "border-bottom-red" : "border-bottom"
                } pb-2  cursor-pointer no-wrap`}
                onClick={() => {
                  this.showViewStatus();
                }}
              >
                <label className="cursor-pointer">
                  {isView == false && <CommonIcon fileName="MyselfIcon" />}
                  {isView == true && <CommonIcon fileName="mySelfIconActive" />}

                  <span className={` ${isView ? "text-color-red" : ""} px-2`}>
                    Details
                  </span>
                </label>
              </div>
              <div
                className={` ${
                  isLou ? "border-bottom-red" : "border-bottom"
                } pb-2 cursor-pointer px-2`}
                onClick={() => {
                  this.showLouStatus();
                }}
                // onClick={this.showLou}
              >
                <label className="cursor-pointer">
                  {isLou == true && <CommonIcon fileName="louactiveicon" />}
                  {isLou == false && <CommonIcon fileName="louicon" />}
                  <span className={` ${isLou ? "text-color-red" : ""} px-2`}>
                    LOU
                  </span>
                </label>
              </div>

              <div
                className={` ${
                  isCourse ? "border-bottom-red" : "border-bottom"
                } cursor-pointer pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showCourseStatus();
                }}
                // onClick={this.showCourseQuestionnaire}
              >
                <label className="cursor-pointer">
                  <lable>
                    {isCourse == true && <CommonIcon fileName="cqActiveIcon" />}
                  </lable>
                  {isCourse == false && (
                    <CommonIcon fileName="CourseQuestionIcon" />
                  )}
                  <span className={` ${isCourse ? "text-color-red" : ""} px-2`}>
                    CQ
                  </span>
                </label>
              </div>
              <div
                className={` ${
                  isPte ? "border-bottom-red" : "border-bottom"
                }   pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showPteStatus();
                }}
                // onClick={this.showPte}
              >
                <label className="cursor-pointer">
                  {isPte == true && <CommonIcon fileName="pteActive" />}
                  {isPte == false && <CommonIcon fileName="pteIcon" />}
                  <span className={` ${isPte ? "text-color-red" : ""} px-2`}>
                    PTE
                  </span>
                </label>
              </div>
              {
                // isMobile == false &&
                <div
                  className={` ${isView && "min-width-editcourse"} ${
                    isLou && "min-width-courseLou"
                  } ${isCourse && "min-width-courseCq"} ${
                    isPte && "min-width-coursePte"
                  } border-bottom`}
                ></div>
              }
            </div>

            {/* //////////////////// Status view ////////////////////// */}

            {isView && (
              <div>
                <div className="row mt-3">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="requestId" />{" "}
                        <span className="pl-5 text-12-bold">Request ID</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.trainingRequestId
                          ? pendingTrainingView.trainingRequestId
                          : "-"}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="VendorNameIcon" />
                        <span className="pl-5 properties-span-2 ">
                          Employee code
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.employeeCode
                          ? pendingTrainingView.employeeCode
                          : "-"}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="VendorCodeIcon" />
                        <span className="pl-7 text-12-bold">Employee name</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.employeeName
                          ? pendingTrainingView.employeeName
                          : "-"}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="CourseCodeIcon" />
                        <span className="pl-7 text-12-bold">Course code</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.courseCode
                          ? pendingTrainingView.courseCode
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <div className="mt-3px">
                          <CommonIcon fileName="CourseTitleIcon" />
                        </div>{" "}
                        <span className="pl-7 text-12-bold">Course title</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.courseTitle
                          ? pendingTrainingView.courseTitle
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Course start date
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.courseStartDate
                          ? moment(pendingTrainingView.courseStartDate).format(
                              "DD-MMM-YYYY",
                            )
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Course end date
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.courseEndDate
                          ? moment(pendingTrainingView.courseEndDate).format(
                              "DD-MMM-YYYY",
                            )
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="RequestedByIcon" />{" "}
                        <span className="pl-7 text-12-bold">Requested by</span>
                        &nbsp;
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.requestedBy
                          ? pendingTrainingView.requestedBy
                          : "-"}
                      </label>
                    </div>
                  </div>
                  {this.state.isEditableTraining !== true && (
                    <>
                      {!this.state.isNonConsecutiveDatesView && (
                        <>
                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                              isMobile ? "" : "pb-3"
                            } `}
                          >
                            <div className="form-group">
                              <label
                                className={`d-flex m-0 label-text ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon fileName="DateIcon" />{" "}
                                <span className="pl-5 text-12-bold">
                                  Start Date
                                </span>
                              </label>
                              <label
                                className={`text-12-normal-400 ${
                                  isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                }`}
                              >
                                {pendingTrainingView.trainingStartDate
                                  ? moment(
                                      pendingTrainingView.trainingStartDate,
                                    ).format("DD-MMM-YYYY")
                                  : "-"}
                              </label>
                            </div>
                          </div>

                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                              isMobile ? "" : "pb-3"
                            } `}
                          >
                            <div className="form-group">
                              <label
                                className={`d-flex m-0 label-text ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon fileName="DateIcon" />{" "}
                                <span className="pl-5 text-12-bold">
                                  End Date
                                </span>
                              </label>
                              <label
                                className={`text-12-normal-400 ${
                                  isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                }`}
                              >
                                {pendingTrainingView.trainingEndDate
                                  ? moment(
                                      pendingTrainingView.trainingEndDate,
                                    ).format("DD-MMM-YYYY")
                                  : "-"}
                              </label>
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.additionalDatesView.length > 0 &&
                        this.state.isNonConsecutiveDatesView && (
                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                              isMobile ? "" : "pb-3"
                            } `}
                          >
                            <div className="form-group">
                              <label
                                className={`d-flex m-0 label-text ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon fileName="DateIcon" />{" "}
                                <span className="pl-5 text-12-bold">
                                  Training Dates
                                </span>
                              </label>
                              <label
                                className={`text-12-normal-400 ${
                                  isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                }`}
                              >
                                {Array.isArray(
                                  this.state.additionalDatesView,
                                ) && this.state.additionalDatesView.length > 0
                                  ? this.state.additionalDatesView.map(
                                      (date, index) => (
                                        <div key={index} className="mb-1">
                                          {moment(date).format("DD-MMM-YYYY")}
                                        </div>
                                      ),
                                    )
                                  : "-"}
                              </label>
                            </div>
                          </div>
                        )}
                    </>
                  )}
                  {this.state.isEditableTraining == true && (
                    <>
                      <div className={isMobile ? "col-12" : "col-12"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start align-items-center"
                          }
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="DateIcon"
                          />{" "}
                          <span className="pl-5 properties-span-2">
                            Is non consecutive dates&nbsp;
                          </span>
                          &nbsp;
                        </label>
                      </div>
                      <div
                        className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
                      >
                        <div class={` ${"form-check form-switch"}`}>
                          <input
                            class={`${"form-check-input toggle-button"}`}
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            onChange={(e) => {
                              this.handleChange({
                                target: {
                                  value: e.target.checked,
                                  name: "isNonConsecutiveDates",
                                },
                              });
                            }}
                            checked={this.state.isNonConsecutiveDates}
                          />
                        </div>
                        {/* <label class={`mt-1 pl-10 view-text`}>
                  {this.state.isNonConsecutiveDates == true ? "Active" : "Inactive"}
                </label> */}
                      </div>
                      {!this.state.isNonConsecutiveDates && (
                        <>
                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
                          >
                            <div className="">
                              <label
                                className={`d-flex label-text mb-2 ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon fileName="DateIcon" />
                                <span className="pl-5 properties-span-2">
                                  Start date&nbsp;
                                  <span className="red-color">*</span>
                                </span>
                              </label>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  autoOk
                                  variant="inline"
                                  inputVariant="outlined"
                                  id="startDate"
                                  // minDate={new Date()}
                                  className="form-control f-12 records-editinput-class startDate password-input-valid"
                                  emptyLabel="dd-mmm-yyyy"
                                  keyboardIcon={
                                    <label className="margin-top-0">
                                      <CommonIcon fileName="calenderDate" />
                                    </label>
                                  }
                                  format="dd-MMM-yyyy"
                                  value={
                                    this.state.trainingRecord.startDate
                                      ? this.state.trainingRecord.startDate
                                      : null
                                  }
                                  size="small"
                                  onChange={(e) =>
                                    this.handleTrainingReqInputChange(
                                      e,
                                      "startDate",
                                    )
                                  }
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                              {this.state.trainingRecordsErrHandler
                                ?.startDateErrMsg ? (
                                <span className="error-message">
                                  This field is required
                                </span>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>

                          <div
                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
                          >
                            <div className="form-group">
                              <label
                                className={`d-flex label-text mb-2 ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon fileName="DateIcon" />
                                <span className="pl-5 properties-span-2">
                                  End date&nbsp;
                                  <span className="red-color">*</span>
                                </span>
                              </label>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  autoOk
                                  variant="inline"
                                  inputVariant="outlined"
                                  id="endDate"
                                  minDate={this.state.trainingRecord.startDate}
                                  className="form-control f-12 records-editinput-class endDate password-input-valid"
                                  emptyLabel="dd-mmm-yyyy"
                                  keyboardIcon={
                                    <CommonIcon fileName="calenderDate" />
                                  }
                                  format="dd-MMM-yyyy"
                                  value={
                                    this.state.trainingRecord.endDate
                                      ? this.state.trainingRecord.endDate
                                      : null
                                  }
                                  size="small"
                                  onChange={(e) =>
                                    this.handleTrainingReqInputChange(
                                      e,
                                      "endDate",
                                    )
                                  }
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                              {this.state.trainingRecordsErrHandler
                                ?.endDateErrMsg ? (
                                <span className="error-message">
                                  This field is required
                                </span>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.isNonConsecutiveDates && (
                        <>
                          {this.state.additionalDates.length > 0 && (
                            <div className="col-12  mt-1">
                              <label
                                className={`d-flex m-0 align-items-center label-text ${
                                  isMobile ? "pt-2" : ""
                                }`}
                              >
                                <CommonIcon
                                  className="properties-img-2"
                                  fileName="DateIcon"
                                />{" "}
                                <span className="pl-5 properties-span">
                                  Training dates
                                </span>
                                <span className="MuiFormHelperText-contained">
                                  *
                                </span>
                              </label>
                            </div>
                          )}
                          {this.state.additionalDates.map((date, index) => (
                            <div
                              key={index}
                              className="col-12 mt-3 mt-lg-2 mb-2 mt-mb-3"
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{ gap: "4px" }}
                              >
                                <div className="flex-grow-1 form-group">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                      autoOk
                                      variant="inline"
                                      minDateMessage=""
                                      maxDateMessage=""
                                      invalidDateMessage=""
                                      inputVariant="outlined"
                                      className="form-control f-12 mt-1"
                                      emptyLabel="dd-mmm-yyyy"
                                      keyboardIcon={
                                        <CommonIcon
                                          className="properties-img-2"
                                          fileName="calenderDate"
                                        />
                                      }
                                      format="dd-MMM-yyyy"
                                      value={date}
                                      size="small"
                                      // minDate={this.addDays(this.state.trainingRecord.startDate, 1)}
                                      // maxDate={this.addDays(this.state.trainingRecord.endDate, -1)}
                                      error={
                                        this.state.additionalErrors[index] !==
                                        ""
                                      }
                                      onChange={(e) =>
                                        this.handleAdditionalDateChange(
                                          e,
                                          index,
                                        )
                                      }
                                      inputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>
                                {this.state.additionalDates.length > 1 && (
                                  <div
                                    className=" d-flex align-items-center justify-content-center"
                                    onClick={() => this.removeDate(index)}
                                  >
                                    <CommonIcon fileName="CrossIcon" />
                                  </div>
                                )}
                              </div>
                              {this.state.additionalErrors[index] && (
                                <span className="send-rework-label">
                                  {this.state.additionalErrors[index]}
                                </span>
                              )}
                            </div>
                          ))}
                          <div
                            className={`col-12 d-flex  mt-2 mb-2 ${this.state.additionalDatesDuplicate ? "justify-content-between" : " justify-content-end "}`}
                          >
                            {this.state.additionalDatesDuplicate && (
                              <span className="send-rework-label">
                                No duplicate training dates allowed
                              </span>
                            )}
                            <button
                              className={`btn pte-add-button1`}
                              onClick={this.addDate}
                            >
                              <CommonIcon
                                fileName="vendoraddIcon"
                                className="modal-img"
                              />
                              <span className="model-label1 pl-5">
                                Add training date
                              </span>
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Requested date
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {pendingTrainingView.requestedDate
                          ? moment(pendingTrainingView.requestedDate).format(
                              "DD-MMM-YYYY",
                            )
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="PropertiesIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Current status
                          {this.state.isEditableTraining == true &&
                            pendingTrainingView?.isManualTraining == true && (
                            <span className="MuiFormHelperText-contained">
                              *
                            </span>
                          )}
                        </span>
                      </label>
                      {this.state.isEditableTraining == true &&
                      pendingTrainingView?.isManualTraining == true ? (
                        <Select
                          id="editCurrentStatus"
                          className={`form-text-box-search`}
                          classNamePrefix="assigngroups"
                          value={this.state.trainingEditData.currentStatus}
                          placeholder="Please select an option"
                          styles={styles}
                          options={this.state.manualTrainingStatus}
                          defaultValue={
                            this.state.trainingEditData.currentStatus ||
                            "Select"
                          }
                          isClearable={true}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isMulti={false}
                          isSearchable={true}
                          onChange={(e) =>
                            this.handleTrainingEditChange(e, "currentStatus")
                          }
                        />
                      ) : (
                        <label
                          className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}
                        >
                          {pendingTrainingView.currentStatus || "-"}
                        </label>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          fileName="trainingbondicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">
                          Training bond
                        </span>
                      </label>
                      {pendingTrainingView.trainingBond ? (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                          <a
                            className={`cursor-pointer text-decoration-none url-label-style d-flex ${
                              isSmallMobile ? "mt-3 mb-2" : "mt-2"
                            }`}
                            onClick={() =>
                              this.handleFilesOpen(
                                pendingTrainingView.trainingBond.fileId,
                              )
                            }
                            target="_blank"
                          >
                            <FileIcon
                              fileName={
                                pendingTrainingView.trainingBond.fileName
                              }
                              className="documentFile"
                            />
                            <span className="pl-7 text-center urlspan">
                              {pendingTrainingView.trainingBond.fileName
                                ? pendingTrainingView.trainingBond.fileName
                                : "-"}
                            </span>
                          </a>
                        </div>
                      ) : (
                        <>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                            <label className="table-noversion"> - </label>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          fileName="trainingbondicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">
                          Training bond status
                        </span>
                      </label>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                        <label className="text-12-normal-400">
                          {" "}
                          {pendingTrainingView.trainingBondStatus
                            ? pendingTrainingView.trainingBondStatus
                            : "-"}{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="trainingbondicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">Certificate</span>
                      </label>
                      {this.state.isEditableTraining == false ||
                      pendingTrainingView?.isManualTraining != true ? (
                        pendingTrainingView.certificate ? (
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                            <a
                              className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}
                              onClick={() =>
                                this.handleFilesOpen(
                                  pendingTrainingView.certificate.fileId,
                                )
                              }
                              target="_blank"
                            >
                              <FileIcon
                                fileName={
                                  pendingTrainingView.certificate.fileName
                                }
                                className="documentFile"
                              />
                              <span className="pl-7 text-center urlspan">
                                {pendingTrainingView.certificate.fileName
                                  ? pendingTrainingView.certificate.fileName
                                  : "-"}
                              </span>
                            </a>
                          </div>
                        ) : (
                          <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                              <label className="table-noversion"> - </label>
                            </div>
                          </>
                        )
                      ) : (
                        <div
                          class={`input-group input-height attach-style ${isSmallMobile ? "mt-3 mb-2" : "mt-1"}`} /* style={{ borderColor: isFileEmpty ? "#d12232" : "" }} */
                        >
                          <div class="d-flex w-100 filesHeight justify-content-evenly">
                            <label
                              class={`file-label-style mt-top-certificate-label ${this.state.trainingEditData.trainingAttachmentName ? "file-select" : ""}`}
                              style={{ margin: "1px 1px 5px 3px" }}
                              aria-describedby="inputGroupFileAddon"
                            >
                              {this.state.trainingEditData
                                .trainingAttachmentName && (
                                <>
                                  <i className="FileIcon-img">
                                    {
                                      <FileIcon
                                        fileName={
                                          this.state.trainingEditData
                                            .trainingAttachmentName
                                        }
                                      />
                                    }
                                  </i>
                                  {
                                    <span className="mt-top-certificate-label">
                                      {
                                        this.state.trainingEditData
                                          .trainingAttachmentName
                                      }
                                    </span>
                                  }
                                  {
                                    <i
                                      className="mt-top-certify"
                                      onClick={() => this.handleFileCloseEdit()}
                                    >
                                      <CommonIcon fileName="crossiconupload" />
                                    </i>
                                  }
                                </>
                              )}
                            </label>
                            <i
                              className="cursor-pointer attachment-icon input-height"
                              onChange={(e) => {
                                this.fileNameAttachmentsEdit(e, "edit");
                              }}
                              onClick={(e) => this.AttachFiles(e)}
                            >
                              <CommonIcon fileName="upload" />
                              <input
                                type="file"
                                class="custom-file-input"
                                id="inputGroupFileEdit"
                                onChange={(e) => {
                                  this.fileNameAttachmentsEdit(e, "edit");
                                }}
                                hidden
                                ref={this.inputFile}
                              />
                            </i>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {this.state.isEditableTraining == true &&
                    pendingTrainingView?.isManualTraining == true && (
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                        >
                          <CommonIcon
                            fileName="DateIcon"
                            className="properties-img"
                          />
                          <span className="pl-10 text-12-bold">
                            Certificate expiry date
                          </span>
                        </label>
                        <div>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              autoOk
                              variant="inline"
                              inputVariant="outlined"
                              className="form-control f-12 records-editinput-class certify-top"
                              emptyLabel="dd-mmm-yyyy"
                              keyboardIcon={
                                <CommonIcon fileName="calenderDate" />
                              }
                              format="dd-MMM-yyyy"
                              value={
                                this.state.trainingEditData.expiryDate
                                  ? this.state.trainingEditData.expiryDate
                                  : null
                              }
                              size="small"
                              onChange={(e) =>
                                this.handleTrainingEditChange(
                                  e,
                                  "certificateExpiryDate",
                                )
                              }
                              inputProps={{
                                readOnly: true,
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="certificateCourseCatalogue"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">
                          Certificate status
                        </span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingTrainingView.certificateStatus
                            ? pendingTrainingView.certificateStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="louicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">LOU status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingTrainingView.louStatus
                            ? pendingTrainingView.louStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="CourseQuestionIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">CQ status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingTrainingView.courseQuestionnaireStatus
                            ? pendingTrainingView.courseQuestionnaireStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="pteIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">PTE status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingTrainingView.pteStatus
                            ? pendingTrainingView.pteStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                      >
                        <CommonIcon
                          fileName="pteIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">Manual Entry</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingTrainingView.isManualTraining == true
                            ? "Yes"
                            : "No"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") === UserStatus.PENDING_FOR_CERT && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                          isMobile ? "" : "pb-3"
                        } `}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex m-0 label-text ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon fileName="DateIcon" />
                            <span className="pl-5 text-12-bold">
                              Expiry date
                            </span>
                          </label>
                          <label
                            className={`text-12-normal-400 ${
                              isSmallMobile ? "mt-3 mb-2" : "mt-2"
                            }`}
                          >
                            {pendingTrainingView.certificateExpiryDate
                              ? moment(
                                  pendingTrainingView.certificateExpiryDate,
                                ).format("DD-MMM-YYYY")
                              : ""}
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  {pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_COMPLETED ||
                  pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_CANCELLED ||
                  pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_REJECTED ? (
                    ""
                  ) : (
                    <>
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon fileName="CommentIcon" />{" "}
                          <span className="pl-5 text-12-bold">Comments</span>
                        </label>
                        <textarea
                          className={`form-control border-radius shiptype-select mt-2 comments-style text-12-bold`}
                          onChange={this.handleTBondComments}
                          style={{
                            borderColor: validateComments ? "#d12232" : "",
                          }}
                          //value="hello"
                          value={trainingComments}
                          ref={this.focusRef}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="d-flex mt-3 gap-2">
                  {pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_COMPLETED ||
                  pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_CANCELLED ||
                  pendingTrainingView.currentStatus
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "") == UserStatus.TRAINING_REJECTED ? (
                    ""
                  ) : (
                    <>
                      <button
                        className={`btn cancelbutton input-height`}
                        onClick={() => this.opencancelRequest()}
                      >
                        <CommonIcon fileName="ButtonRejectApprovalIcon" />
                        Cancel request
                      </button>
                    </>
                  )}
                  {typeof pendingTrainingView?.isManualTraining === "boolean" &&
                    (this.state.currentUser === UserRole.ADMIN ||
                      this.state.currentUser === UserRole.MANAGER) && (
                      <>
                        {this.state.isEditableTraining == false && (
                          <button
                            className={`btn btn-light input-group input-height f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`}
                            onClick={() => this.trainingEdit()}
                          >
                            <CommonIcon fileName="ButtonSubmitIcon" />
                            <span className="model-label pl-10">Edit</span>
                          </button>
                        )}
                        {this.state.isEditableTraining == true && (
                          <button
                            className={`btn btn-light input-group input-height f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`}
                            onClick={() => this.submitTrainingUpdate()}
                          >
                            <CommonIcon fileName="ButtonSubmitIcon" />
                            <span className="model-label pl-10">Update</span>
                          </button>
                        )}
                        {this.state.isEditableTraining == true && (
                          <button
                            className={`btn cancelbutton input-height`}
                            onClick={() => this.trainingCancel()}
                          >
                            <CommonIcon fileName="ButtonRejectApprovalIcon" />
                            Cancel
                          </button>
                        )}
                      </>
                    )}
                </div>

                <div className="row mt-3">
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="VersionIcon" />
                        <span className="pl-5 properties-span">
                          History log
                        </span>
                      </label>
                      <div className="table-responsive table-responsive-scroll mb-4 mt-3">
                        <table id="historyTable">
                          <tbody>
                            {historyLogList.length !== 0 ? (
                              historyLogList.map((i, index) => (
                                <>
                                  <tr id={index} key={index}>
                                    <td className="title-width fw-bold">
                                      {i.status}
                                    </td>
                                    <td
                                      className={`history-date no-wrap ${
                                        isRadioMobile ? "date-width" : ""
                                      }`}
                                    >
                                      {i.createdDate
                                        ? moment(
                                            new Date(Date.parse(i.createdDate)),
                                          ).format("DD-MMM-YYYY h:mm A")
                                        : ""}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2} className="fw-bold">
                                      {" "}
                                      {i.reviewer}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2} className="history-comment">
                                      {i.comments}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td className="table-noversion" colSpan={3}>
                                  No history log to display
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* /////////////////////////// Lou View /////////////////////// */}

            {isLou && (
              <div className="row mt-3">
                <div className="mt-2 scroll">
                  {LouDetails?.questions?.length > 0 ? (
                    LouDetails?.questions?.map((item, questionIndex) => (
                      <div
                        className="text-12-normal-400 d-flex pb-2"
                        key={questionIndex}
                      >
                        {item?.question?.includes("textbox") ? (
                          <>
                            <div className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </div>
                            <p className="pl-5 pr-2 lh-base">
                              {item.question
                                .split("textbox")
                                .map((part, partIndex) => (
                                  <React.Fragment key={partIndex}>
                                    {partIndex > 0 && (
                                      <span className="lou-min-width border-bottom pl-10 pr-10">
                                        {
                                          item?.answer?.split("&*&")[
                                            partIndex - 1
                                          ]
                                        }
                                        {/* <input
                                        className="form-control height-18 remove-border LOUID color-white"
                                        name="louName"
                                        value={item?.answer?.split(",")[partIndex - 1]}
                                        disabled={true}
                                      /> */}
                                      </span>
                                    )}
                                    <>
                                      <span
                                        className="word-css"
                                        dangerouslySetInnerHTML={{
                                          __html: part
                                            ? part.replace(/\n/g, "<br>")
                                            : "",
                                        }}
                                      ></span>
                                    </>
                                  </React.Fragment>
                                ))}
                            </p>
                          </>
                        ) : (
                          <p className="pl-zero pr-2 pt-2 lh-base">
                            <span className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </span>
                            <span
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: item.question
                                  ? item.question.replace(/\n/g, "<br>")
                                  : "",
                              }}
                            ></span>
                          </p>
                        )}
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="text-center">
                        <label className="text-16-normal fw-bold text-color-red">
                          {this.state.pendingTrainingView.louStatus?.toLowerCase() ===
                          "lou not applicable"
                            ? "LOU is not applicable for this training."
                            : "LOU is not submitted for this training."}
                        </label>
                      </div>
                    </>
                  )}
                  <div>
                    {LouDetails?.questions?.length > 0 && (
                      <>
                        <div className="text-12-normal-400 mt-3">
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == true}
                            />
                            <span className="mx-3">I agree</span>
                          </div>
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == false}
                            />
                            <span className="mx-3">I don't agree</span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* ////////////   Course Questionnaire View //////////////// */}

            {isCourse && (
              <div>
                <div className="row ">
                  {this.state.courseAdd?.length > 0 ? (
                    <>
                      <div className={`col-12 pr-10`}>
                        <div
                          className={`${
                            iswebMobile ? "col-12" : "col-12 pl-0"
                          } col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${
                            iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                        ></div>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"} row  `}>
                        <div
                          className={` table-responsive table-responsive-scroll `}
                        >
                          <table className="course-table-width-course-view ">
                            <>
                              <thead>
                                <tr className="border-top height-course">
                                  <th className="col-1 text-12-bold pt-2 border-right border-left pl-10 pb-20">
                                    <span>S.no</span>
                                  </th>
                                  <th className="col-6 pt-2 text-12-bold cq-box-view border-right border-left pl-10 pb-20">
                                    Question
                                  </th>
                                  <th className="col-5 border-right text-12-bold pt-2 border-left pl-10 pb-20">
                                    Answer
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="border-bottom ">
                                {this.state.courseAdd?.length > 0 ? (
                                  this.state.courseAdd.map((item, index) => (
                                    <>
                                      <tr
                                        key={index}
                                        className={`${
                                          this.state.courseAdd?.length !==
                                            index + 1 && "border-bottom"
                                        } `}
                                      >
                                        <td className="col-1 text-12-bold mt-2 border-right border-left pl-10 pb-80 ">
                                          {index + 1}
                                        </td>
                                        <td className="col-6  cq-box-view mt-2 border-right border-left pl-10 pr-10 pb-20 text-12-normal-400">
                                          <textarea
                                            className={`text-wrap color-white form-text-box2 resize-none border-none border-radius-0 w-100`}
                                            rows="3"
                                            value={item.question}
                                            readOnly={true}
                                            disabled={true}
                                          >
                                            {item.question}
                                          </textarea>
                                        </td>
                                        <td
                                          className={`col-5 mt-2 pl-10 pb-20 text-wrap border-right text-12-normal-400 ${
                                            isMobile
                                              ? "form-control-mobile"
                                              : ""
                                          }`}
                                        >
                                          {this.state.CourseQuestAnswers?.map(
                                            (courseOption) => (
                                              <>
                                                <input
                                                  className={`height ${
                                                    courseOption?.id ===
                                                      item?.answerId &&
                                                    "color-black"
                                                  }`}
                                                  type="radio"
                                                  // name="test"
                                                  disabled={
                                                    courseOption?.id !==
                                                    item?.answerId
                                                  }
                                                  checked={
                                                    courseOption?.id ===
                                                    item?.answerId
                                                  }
                                                />
                                                <label
                                                  className={`${
                                                    isMobile ? "pl-3" : "pl-10"
                                                  } label-text`}
                                                >
                                                  {courseOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ),
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                ) : (
                                  <tr>
                                    <td className="border-right border-left"></td>
                                    <td
                                      colSpan={7}
                                      className="table-nodata text-center border-right p-2"
                                    >
                                      {"No record found"}
                                    </td>
                                  </tr>
                                )}

                                <tr className="border-right border-left">
                                  <td></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal align-text-middle fw-bold text-color-red">
                            {this.state.pendingTrainingView.courseQuestionnaireStatus?.toLowerCase() ===
                            "cq not applicable"
                              ? "CQ is not applicable for this training."
                              : "CQ is not submitted for this training."}
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* //////////////// PTE VIEW ////////////////// */}
            {isPte && (
              <div>
                <div className="row">
                  {this.state.PTE?.length > 0 ? (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${
                          iswebMobile ? "mt-2" : isMobile ? "" : ""
                        } `}
                      >
                        <button
                          className={` pte-label-button label-text ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon fileName="skillKonwIcon" />
                          <span className="pl-5 properties-span-2">
                            Capability and Knowledge Evaluation
                          </span>
                        </button>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={` table-responsive table-responsive-scroll `}
                        >
                          <table className="postskill-table-width">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" slno text-12-bold border-right border-left">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Capability & knowledge
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Level of capability and knowledge
                                  (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge
                                  (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge
                                  (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom text-12-normal-400">
                              {this.state.PTE?.length > 0 ? (
                                this.state.PTE.map((item, index) => (
                                  <tr
                                    key={index + "PTE"}
                                    className={`${this.state.PTE?.length !== index + 1 && "border-bottom"} `}
                                  >
                                    <td className=" text-12-bold border-right border-left pl-10 pb-80">
                                      {index + 1}
                                    </td>

                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box2 resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        readOnly={true}
                                        disabled={true}
                                        // disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={` pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {this.state.pteAnswersOption?.map(
                                        (pteOption1, index) => (
                                          <>
                                            <input
                                              className={`height ${
                                                pteOption1?.id ===
                                                  item?.ptE1AnswerId &&
                                                "color-black"
                                              }`}
                                              type="radio"
                                              // name={"test" + index + "pte1"}
                                              checked={
                                                pteOption1?.id ===
                                                item?.ptE1AnswerId
                                              }
                                              disabled={
                                                pteOption1?.id !==
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${
                                                isMobile ? "pl-3" : "pl-10"
                                              }`}
                                            >
                                              {pteOption1?.name}
                                            </label>
                                            <br />
                                          </>
                                        ),
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id === item?.ptE2AnswerId && "color-black"}`}
                                                  type="radio"
                                                  // name={"test" + index + "pte2"}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${
                                                    isMobile ? "pl-3" : "pl-10"
                                                  }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ),
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2,
                                          ) ===
                                            index + 1 && (
                                            <label className="text-color-red">
                                              PTE 2 is not submitted for this
                                              training.
                                            </label>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id === item?.ptE3AnswerId && "color-black"}`}
                                                  type="radio"
                                                  // name={"test" + index + "pte3"}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${
                                                    isMobile ? "pl-3" : "pl-10"
                                                  }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ),
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2,
                                          ) ===
                                            index + 1 && (
                                            <label className="text-color-red">
                                              PTE 3 is not submitted for this
                                              training.
                                            </label>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td
                                    colSpan={7}
                                    className="table-nodata text-center border-right p-2"
                                  >
                                    {"No record found"}
                                  </td>
                                </tr>
                              )}
                              <tr className="border-right border-left">
                                <td></td>
                                <td className="border-right border-left"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${
                          iswebMobile ? "mt-2" : isMobile ? "" : ""
                        } `}
                      >
                        <button
                          className={`pte-label-button label-text ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon fileName="jobIcon" />
                          <span className="pl-5 properties-span-2">
                            List of Job/Task/Activity Undertake After Completing
                            Training
                          </span>
                        </button>
                      </div>

                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={`table-responsive table-responsive-scroll mt-20`}
                        >
                          <table className="pte-table-width text-12-normal-400">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" skill-slno text-12-bold border-right border-left">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Job / Task / Activity
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom">
                              {this.state.pteJob?.length > 0 ? (
                                this.state.pteJob?.map((item, index) => (
                                  <tr
                                    key={index + "PTEJOB"}
                                    className={`${
                                      this.state.pteJob?.length !== index + 1 &&
                                      "border-bottom"
                                    } `}
                                  >
                                    <td className="mt-1 text-12-bold border-right border-left pl-10 pb-50">
                                      {index + 1}
                                    </td>
                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box3 border-none resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        // readOnly = {this.state.isPteSubmit}
                                        disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {this.state.pteJobAnswerOption?.map(
                                        (pteJobOption) => (
                                          <>
                                            <input
                                              className={`height ${
                                                pteJobOption?.id ===
                                                  item?.ptE1AnswerId &&
                                                "color-black"
                                              }`}
                                              type="radio"
                                              // name={"test" + index + "ptejob1"}
                                              disabled={
                                                pteJobOption?.id !==
                                                item?.ptE1AnswerId
                                              }
                                              checked={
                                                pteJobOption?.id ===
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${
                                                isMobile ? "pl-3" : "pl-10"
                                              }`}
                                            >
                                              {pteJobOption?.name}
                                            </label>
                                            <br />
                                          </>
                                        ),
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id === item?.ptE2AnswerId && "color-black"}`}
                                                  type="radio"
                                                  // name={"test" + index + "ptejob2"}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${
                                                    isMobile ? "pl-3" : "pl-10"
                                                  }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ),
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2,
                                          ) ===
                                            index + 1 && (
                                            <label className="text-color-red">
                                              PTE 2 is not submitted for this
                                              training.
                                            </label>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${
                                        isMobile ? "form-control-mobile" : ""
                                      }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id === item?.ptE3AnswerId && "color-black"}`}
                                                  type="radio"
                                                  // name={"test" + index + "ptejob3"}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${
                                                    isMobile ? "pl-3" : "pl-10"
                                                  }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ),
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2,
                                          ) ===
                                            index + 1 && (
                                            <label className="text-color-red">
                                              PTE 3 is not submitted for this
                                              training.
                                            </label>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td className="table-nodata text-center border-right border-left p-2">
                                    No record found
                                  </td>
                                  <td></td>
                                  <td className="border-right"></td>
                                </tr>
                              )}
                              {/* <tr>
                                              <td></td>
                                              <td>
                                                {jobEmptyId?.length > 0 ? (
                                                  <span className="send-rework-label">
                                                    All field is required
                                                  </span>
                                                ) : (
                                                  <></>
                                                )}
                                              </td>
                                            </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal fw-bold text-color-red">
                            {this.state.pendingTrainingView.pteStatus?.toLowerCase() ===
                            "pte not applicable"
                              ? "PTE is not applicable for this training."
                              : "PTE is not submitted for this training."}
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Search screen */}

        <div
          class="offcanvasStyle offcanvas offcanvas-end pb-3"
          tabIndex="-1"
          aria-labelledby="offcanvasScrollingLabel"
          aria-modal="true"
          role="dialog"
          id="sideScreen"
        >
          <div class="offcanvas-header">
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              onClick={() => this.closeTrainingSearchModal()}
            >
              <CommonIcon fileName="CrossIcon" />
            </button>{" "}
            <button
              className="display-none"
              id="closeSideScreen"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="requestId" />
                    <span className="pl-5 properties-span-2">Request ID</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-text-box-search  records-editinput-class"
                    value={this.state.searchInputData.trainingRequestId}
                    onChange={(e) =>
                      this.handleInputchange(e, "trainingRequestId")
                    }
                    required
                  />
                </div>
              </div>

              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="ContactPersonIcon" />
                    <span className="pl-5 properties-span-2 ">
                      Employee code
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-text-box-search  records-editinput-class"
                    value={this.state.searchInputData.employeeCode}
                    onChange={(e) => this.handleInputchange(e, "employeeCode")}
                    required
                  />
                </div>
              </div>

              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="VendorCodeIcon" />
                    <span className="pl-7 properties-span-2">
                      Employee name
                    </span>
                  </label>
                  <Select
                    className={`form-text-box-search ${
                      this.state.employeeNameEmpty && "border-red"
                    }  `}
                    classNamePrefix="assigngroups"
                    value={this.state.selectEmployeeName}
                    placeholder="Please select an option"
                    styles={styles}
                    options={this.state.employeeNameList}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    defaultValue={this.state.selectEmployeeName || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={this.onchangeEmployeeName}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="CourseCodeIcon" />
                    <span className="pl-5 properties-span-2">Course code</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-text-box-search  records-editinput-class"
                    value={this.state.searchInputData.courseCode}
                    onChange={(e) => this.handleInputchange(e, "courseCode")}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="CourseTitleIcon" />
                    <span className="pl-5 properties-span-2">Course title</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control form-text-box-search  records-editinput-class`}
                    value={this.state.searchInputData.courseTitle}
                    onChange={(e) => this.handleInputchange(e, "courseTitle")}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="RequestedByIcon" />
                    <span className="pl-5 properties-span-2">Requested by</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control form-text-box-search records-editinput-class`}
                    value={this.state.searchInputData.requestedBy}
                    onChange={(e) => this.handleInputchange(e, "requestedBy")}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text mb-2 ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="DateIcon" />
                    <span className="pl-5 properties-span-2">Start date</span>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control f-12 search-date"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<CommonIcon fileName="calenderDate" />}
                      format="dd-MMM-yyyy"
                      value={
                        this.state.searchInputData.startDate
                          ? this.state.searchInputData.startDate
                          : null
                      }
                      size="small"
                      onChange={(e) => this.handleInputchange(e, "startDate")}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text mb-2 ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="DateIcon" />
                    <span className="pl-5 properties-span-2">End date</span>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control f-12 search-date"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<CommonIcon fileName="calenderDate" />}
                      format="dd-MMM-yyyy"
                      value={
                        this.state.searchInputData.endDate
                          ? this.state.searchInputData.endDate
                          : null
                      }
                      size="small"
                      onChange={(e) => this.handleInputchange(e, "endDate")}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text mb-2 ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="DateIcon" />
                    <span className="pl-5 properties-span-2">
                      Requested date
                    </span>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control f-12 search-date"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<CommonIcon fileName="calenderDate" />}
                      format="dd-MMM-yyyy"
                      value={
                        this.state.searchInputData.requestedDate
                          ? this.state.searchInputData.requestedDate
                          : null
                      }
                      size="small"
                      onChange={(e) =>
                        this.handleInputchange(e, "requestedDate")
                      }
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="PropertiesIcon" />
                    <span className="pl-5 properties-span-2">
                      Current status
                    </span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.currentStatus} onChange={(e) => this.handleInputchange(e, "currentStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.currentStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.currentStatusList}
                    defaultValue={this.state.currentStatus || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.handleCurrentStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="trainingbondicon" />
                    <span className="pl-5 properties-span-2">
                      Training bond status
                    </span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.trainingBondStatus} onChange={(e) => this.handleInputchange(e, "trainingBondStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.trainingBondStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.trainingBondstatusList}
                    defaultValue={this.state.trainingBondStatus || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangeTbStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="certificateCourseCatalogue" />
                    <span className="pl-5 properties-span-2">
                      Certificate status
                    </span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.certificateStatus} onChange={(e) => this.handleInputchange(e, "certificateStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.certificateStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.certificateStatusList}
                    defaultValue={this.state.certificateStatus || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangeCertificateStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="louicon" />
                    <span className="pl-5 properties-span-2">LOU status</span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.louStatus} onChange={(e) => this.handleInputchange(e, "louStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.louStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.louStatusList}
                    defaultValue={this.state.louStatus || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangeLouStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="CourseQuestionIcon" />
                    <span className="pl-5 properties-span-2">CQ status</span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.courseQuestionnaireStatus} onChange={(e) => this.handleInputchange(e, "courseQuestionnaireStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.courseQuestionnaireStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.cqStatusList}
                    defaultValue={
                      this.state.courseQuestionnaireStatus || "Select"
                    }
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangeCqStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                  isRadioMobile ? "mt-3" : "mt-2"
                } ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="pteIcon" />
                    <span className="pl-5 properties-span-2">PTE status</span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.pteStatus} onChange={(e) => this.handleInputchange(e, "pteStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.pteStatus}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={this.state.pteStatusList}
                    defaultValue={this.state.pteStatus || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangePteStatus(e)}
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"} ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="pteIcon" />
                    <span className="pl-5 properties-span-2">Manual Entry</span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.pteStatus} onChange={(e) => this.handleInputchange(e, "pteStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.manualEntryList}
                    placeholder="Please select an option"
                    styles={styles}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    options={manualEntryOptions}
                    defaultValue={this.state.manualEntryList || "Select"}
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.onchangeManualEntry(e)}
                  />
                </div>
              </div>
            </div>
            {this.state.validationMsg ? (
              <span className="properties-span-2 text-danger">
                Atleast one field is mandatory
              </span>
            ) : (
              ""
            )}

            <div className="d-flex mt-20">
              <button
                className={`btn rejectbutton d-flex gap-1`}
                onClick={() => this.closeTrainingSearchModal("clear")}
              >
                <span className="mt-0">
                  <CommonIcon className="mt-0" fileName="clearIcon1" />
                </span>
                <span className="pl-vendor3 pl-2">Clear</span>
              </button>
              <button
                className={`btn approvebutton ml-10 d-flex gap-1`}
                onClick={() => this.validateSearchRecords()}
              >
                <span className="">
                  <CommonIcon fileName="searchableIcon" />
                </span>
                <span className="model-label pl-vendor3 pl-2">Search</span>
              </button>
            </div>
          </div>
        </div>

        <div
          class="offcanvasStyle offcanvas offcanvas-end pb-3"
          tabIndex="-1"
          aria-labelledby="offcanvasScrollingLabel"
          aria-modal="true"
          role="dialog"
          id="offcanvasAddTraining"
        >
          <div class="offcanvas-header">
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
              Training Request
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : "pr-0"}`}
              onClick={() => this.closeTrainingModal()}
            >
              <CommonIcon fileName="CrossIcon" />
            </button>{" "}
            <button
              className="display-none"
              id="closeAddTrainingModal"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <div>
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CourseCodeIcon"
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Employee name
                    </span>
                    <span className="MuiFormHelperText-contained">*</span>
                  </label>
                  <Select
                    className={`text-12-normal-select my-input-class`}
                    classNamePrefix="assigngroups"
                    placeholder="Please select an option"
                    styles={styles}
                    value={this.state.trainingRecord?.selectedEmployee}
                    options={this.state.employeeNameList}
                    defaultValue={"Select"}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    isClearable={true}
                    isMulti={false}
                    isSearchable={true}
                    onChange={this.onchangeEmployee}
                    id="selectedEmployee"
                  />
                  {this.state.trainingRecordsErrHandler
                    ?.selectedEmployeeErrMsg ? (
                    <span className="error-message">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="ContactPersonIcon" />
                    <span className="pl-5 properties-span-2 ">
                      Employee code
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-text-box-search input-height records-editinput-class"
                    value={this.state.trainingRecord?.userCode || ""}
                    disabled
                    required
                  />
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                }`}
              >
                <div>
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CourseCodeIcon"
                    />{" "}
                    <span className="pl-10 properties-search-span">Course</span>
                    <span className="MuiFormHelperText-contained">*</span>
                  </label>
                  <Select
                    className={`text-12-normal-select my-input-class`}
                    classNamePrefix="assigngroups"
                    placeholder="Please select an option"
                    styles={styles}
                    value={this.state.trainingRecord.selectedCourse}
                    options={this.state.courseCodeList}
                    defaultValue={
                      this.state.trainingRecord.selectedCourse || "Select"
                    }
                    isClearable={true}
                    isMulti={false}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    isSearchable={true}
                    onChange={this.onchangeCourse}
                    id="selectedCourse"
                  />
                  {this.state.trainingRecordsErrHandler
                    ?.selectedCourseErrMsg ? (
                    <span className="error-message">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="ContactPersonIcon" />
                    <span className="pl-5 properties-span-2 ">Course code</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-text-box-search input-height records-editinput-class"
                    value={this.state.trainingRecord?.courseCode || ""}
                    disabled
                    required
                  />
                </div>
              </div>
              <div className={isMobile ? "col-12" : "col-12"}>
                <label
                  className={
                    isMobile
                      ? "d-flex pt-2 m-0"
                      : "d-flex m-0 text-left float-start align-items-center"
                  }
                >
                  <CommonIcon
                    className="properties-img-2"
                    fileName="DateIcon"
                  />{" "}
                  <span className="pl-5 properties-span-2">
                    Is non consecutive dates&nbsp;
                  </span>
                  &nbsp;
                </label>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
              >
                <div class={` ${"form-check form-switch"}`}>
                  <input
                    class={`${"form-check-input toggle-button"}`}
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    onChange={(e) => {
                      this.handleChange({
                        target: {
                          value: e.target.checked,
                          name: "isNonConsecutiveDates",
                        },
                      });
                    }}
                    checked={this.state.isNonConsecutiveDates}
                  />
                </div>
                {/* <label class={`mt-1 pl-10 view-text`}>
                  {this.state.isNonConsecutiveDates == true ? "Active" : "Inactive"}
                </label> */}
              </div>
              {!this.state.isNonConsecutiveDates && (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="">
                      <label
                        className={`d-flex label-text mb-2 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          Start date&nbsp;<span className="red-color">*</span>
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          id="startDate"
                          // minDate={new Date()}
                          className="form-control f-12 records-editinput-class startDate password-input-valid"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={
                            <label className="margin-top-0">
                              <CommonIcon fileName="calenderDate" />
                            </label>
                          }
                          format="dd-MMM-yyyy"
                          value={
                            this.state.trainingRecord.startDate
                              ? this.state.trainingRecord.startDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleTrainingReqInputChange(e, "startDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                      {this.state.trainingRecordsErrHandler?.startDateErrMsg ? (
                        <span className="error-message">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          End date&nbsp;<span className="red-color">*</span>
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          id="endDate"
                          minDate={this.state.trainingRecord.startDate}
                          className="form-control f-12 records-editinput-class endDate password-input-valid"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.trainingRecord.endDate
                              ? this.state.trainingRecord.endDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleTrainingReqInputChange(e, "endDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                      {this.state.trainingRecordsErrHandler?.endDateErrMsg ? (
                        <span className="error-message">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </>
              )}
              {this.state.isNonConsecutiveDates && (
                <>
                  {this.state.additionalDates.length > 0 && (
                    <div className="col-12  mt-1">
                      <label
                        className={`d-flex m-0 align-items-center label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-5 properties-span">
                          Training dates
                        </span>
                        <span className="MuiFormHelperText-contained">*</span>
                      </label>
                    </div>
                  )}
                  {this.state.additionalDates.map((date, index) => (
                    <div
                      key={index}
                      className="col-12 mt-3 mt-lg-2 mb-2 mt-mb-3"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "4px" }}
                      >
                        <div className="flex-grow-1 form-group">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              autoOk
                              variant="inline"
                              minDateMessage=""
                              maxDateMessage=""
                              invalidDateMessage=""
                              inputVariant="outlined"
                              className="form-control f-12 mt-1"
                              emptyLabel="dd-mmm-yyyy"
                              keyboardIcon={
                                <CommonIcon
                                  className="properties-img-2"
                                  fileName="calenderDate"
                                />
                              }
                              format="dd-MMM-yyyy"
                              value={date}
                              size="small"
                              // minDate={this.addDays(this.state.trainingRecord.startDate, 1)}
                              // maxDate={this.addDays(this.state.trainingRecord.endDate, -1)}
                              error={this.state.additionalErrors[index] !== ""}
                              onChange={(e) =>
                                this.handleAdditionalDateChange(e, index)
                              }
                              inputProps={{
                                readOnly: true,
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                        {this.state.additionalDates.length > 1 && (
                          <div
                            className=" d-flex align-items-center justify-content-center"
                            onClick={() => this.removeDate(index)}
                          >
                            <CommonIcon fileName="CrossIcon" />
                          </div>
                        )}
                      </div>
                      {this.state.additionalErrors[index] && (
                        <span className="send-rework-label">
                          {this.state.additionalErrors[index]}
                        </span>
                      )}
                    </div>
                  ))}
                  <div
                    className={`col-12 d-flex  mt-2 mb-2 ${this.state.additionalDatesDuplicate ? "justify-content-between" : " justify-content-end "}`}
                  >
                    {this.state.additionalDatesDuplicate && (
                      <span className="send-rework-label">
                        No duplicate training dates allowed
                      </span>
                    )}
                    <button
                      className={`btn pte-add-button1`}
                      onClick={this.addDate}
                    >
                      <CommonIcon
                        fileName="vendoraddIcon"
                        className="modal-img"
                      />
                      <span className="model-label1 pl-5">
                        Add training date
                      </span>
                    </button>
                  </div>
                </>
              )}
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text${isMobile ? "pt-2" : ""}`}
                  >
                    <CommonIcon fileName="PropertiesIcon" />
                    <span className="pl-5 properties-span-2">
                      Current status&nbsp;<span className="red-color">*</span>
                    </span>
                  </label>
                  {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.currentStatus} onChange={(e) => this.handleInputchange(e, "currentStatus")} required /> */}
                  <Select
                    className={`form-text-box-search`}
                    classNamePrefix="assigngroups"
                    value={this.state.trainingRecord?.currentStatusSelected}
                    placeholder="Please select an option"
                    styles={styles}
                    options={this.state.manualTrainingStatus}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    defaultValue={
                      this.state.trainingRecord?.currentStatusSelected ||
                      "Select"
                    }
                    isClearable={true}
                    id="currentStatusSelected"
                    isMulti={false}
                    isSearchable={true}
                    onChange={(e) => this.handleCurrentStatusTrainingRecord(e)}
                  />
                  {this.state.trainingRecordsErrHandler
                    ?.currentStatusSelectedErrMsg ? (
                    <span className="error-message">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <label
                  className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}
                >
                  <CommonIcon fileName="docAttach" />{" "}
                  <span className="pl-5 text-12-bold">Certificate</span>
                </label>

                <div
                  class={`input-group input-height attach-style ${isSmallMobile ? "mt-3 mb-2" : "mt-1"}`} /* style={{ borderColor: isFileEmpty ? "#d12232" : "" }} */
                >
                  <div class="d-flex w-100 filesHeight justify-content-evenly">
                    <label
                      class={`file-label-style mt-top-certificate-label ${this.state.trainingAttachmentName !== "" ? "file-select" : ""}`}
                      style={{ margin: "1px 1px 5px 3px" }}
                      aria-describedby="inputGroupFileAddon"
                    >
                      {this.state.trainingAttachmentName != "" && (
                        <>
                          <i className="FileIcon-img">
                            {
                              <FileIcon
                                fileName={this.state.trainingAttachmentName}
                              />
                            }
                          </i>
                          {
                            <span className="mt-top-certificate-label">
                              {this.state.trainingAttachmentName}
                            </span>
                          }
                          {
                            <i
                              className="mt-top-certify"
                              onClick={() => this.handleFileClose()}
                            >
                              <CommonIcon fileName="crossiconupload" />
                            </i>
                          }
                        </>
                      )}
                    </label>
                    <input
                      type="file"
                      class="custom-file-input"
                      id="inputGroupAdd"
                      onChange={(e) => {
                        this.fileNameAttachments(e);
                      }}
                      ref={this.inputFileAdd}
                      hidden
                    />
                    <i
                      className="attachment-icon input-height cursor-pointer"
                      onChange={(e) => {
                        this.fileNameAttachments(e);
                      }}
                      onClick={() => this.AttachFilesAdd()}
                    >
                      <CommonIcon fileName="upload" />
                    </i>
                  </div>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex label-text mb-2 ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon fileName="DateIcon" />
                    <span className="pl-5 properties-span-2">
                      Certificate expiry date
                    </span>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control f-12 records-editinput-class"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<CommonIcon fileName="calenderDate" />}
                      format="dd-MMM-yyyy"
                      value={
                        this.state.trainingRecord.certificateExpiryDate
                          ? this.state.trainingRecord.certificateExpiryDate
                          : null
                      }
                      size="small"
                      onChange={(e) =>
                        this.handleTrainingReqInputChange(
                          e,
                          "certificateExpiryDate",
                        )
                      }
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>

            <div className="d-flex mt-20 gap-2">
              <button
                className={`btn btn-light input-group offcavasclose filter-cancelbtn p-2`}
                onClick={() => this.closeTrainingModal()}
              >
                <CommonIcon fileName="ButtonRejectIcon" className="modal-img" />
                <span className="send-rework-label pl-5">Cancel</span>
              </button>
              <button
                className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                onClick={() => this.submitTrainingRecord()}
              >
                <CommonIcon
                  fileName="ButtonSubmitIcon"
                  className="modal-img"
                ></CommonIcon>
                <span className="model-label pl-5">
                  {/* {isSubmitTrue ? "Update" : "Submit"} */}
                  Submit
                </span>
              </button>
            </div>
          </div>
        </div>
        <WarningComponent
          message={"Are you sure you want to cancel the training?"}
          isMobile={this.state.isMobile}
          onYesClick={() => this.handleRejectTraining()}
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={this.state.totalCount}
          reset={pageNewCount}
        />
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrainingRecords),
);
